// Simple i18n dictionary. Italian is complete; other languages fallback to IT for keys not translated.
export const translations = {
  it: {
    // Navigation
    nav_home: "Home",
    nav_catalog: "Catalogo",
    nav_blog: "Guide & Blog",
    nav_about: "Chi Siamo",
    nav_contact: "Contatti",
    nav_accessories: "Accessori",

    // Header
    header_wa_cta: "Contattaci per maggiori info",
    header_cart: "Carrello",
    header_login: "Accedi",
    header_account_my: "Il mio account",
    header_account_orders: "I miei ordini",
    header_account_logout: "Esci",
    header_promo: "Spedizione express gratuita 24-48h · Pagamento alla consegna disponibile · Garanzia 24 mesi",

    // CTAs
    cta_find: "Trova il tuo modello",
    cta_catalog: "Guarda il catalogo",
    trust_warranty: "Garanzia inclusa",
    trust_shipping: "Spedizione 24-48h",
    trust_wa: "Assistenza WhatsApp",

    // Home sections
    section_why: "Perché scegliere audrivio",
    section_best: "I più venduti",
    section_sale: "In offerta ora",
    section_how: "Come funziona",
    section_reviews: "Cosa dicono i clienti",
    hero_badge: "Autoradio Android Plug&Play",
    hero_title: "Il tuo abitacolo, finalmente al livello del 2026.",
    hero_subtitle: "Autoradio Android su misura per il tuo modello. Zero splicing, installazione in 30 minuti, garanzia inclusa.",
    why_kicker: "Perché noi",
    best_kicker: "Bestseller",
    sale_kicker: "Offerte",
    how_kicker: "Il processo",
    reviews_kicker: "Recensioni verificate",
    see_all: "Vedi tutti",
    see_all_sale: "Vedi tutte",
    why_1_title: "Garanzia inclusa 24 mesi",
    why_1_desc: "Ogni radio audrivio è coperta da garanzia ufficiale con assistenza in italiano.",
    why_2_title: "Assistenza reale su WhatsApp",
    why_2_desc: "Team tecnico che risponde entro 15 minuti in orario lavorativo.",
    why_3_title: "Installazione facile Plug&Play",
    why_3_desc: "Zero splicing. Colleghi solo i connettori dedicati per il tuo modello.",
    why_4_title: "Resi facili 14 giorni",
    why_4_desc: "Cambio idea? Riprendiamo il prodotto entro 14 giorni, spedizione inclusa.",
    step_1_title: "Scegli la tua auto",
    step_1_desc: "Marca, modello e anno: ti mostriamo solo la radio compatibile.",
    step_2_title: "Ricevi il kit completo",
    step_2_desc: "Cornice, cablaggio, staffe e adattatori — già dentro la scatola.",
    step_3_title: "Installa in 30-40 minuti",
    step_3_desc: "Zero taglio di cavi. Il tutorial passo-passo è nella confezione.",

    // Vehicle finder
    finder_title: "Trova la radio giusta per la tua auto",
    finder_brand: "Marca auto",
    finder_model: "Modello",
    finder_cta: "Cerca compatibilità",
    finder_console_title: "Trova la radio per la tua auto",
    finder_console_sub: "SELECT BRAND · MODEL",
    finder_label_brand: "Marca",
    finder_label_model: "Modello",
    finder_placeholder_brand: "Seleziona marca",
    finder_placeholder_model_pre: "Prima scegli la marca",
    finder_placeholder_model: "Seleziona modello",
    finder_foot_kit: "· plug&play kit",
    finder_foot_ship: "· 24-48h",
    finder_foot_warranty: "· 24 mesi",

    // Product / cart
    add_to_cart: "Aggiungi al carrello",
    pdp_buy_now: "Compra ora",
    ask_whatsapp: "Chiedi su WhatsApp",
    view_cart: "Vedi carrello",
    checkout: "Procedi al checkout",
    empty_cart: "Il carrello è vuoto",

    // Footer
    footer_shop: "Negozio",
    footer_support: "Assistenza",
    footer_legal: "Legale",
    footer_manage_cookies: "Gestisci cookie",
    footer_tagline: "Autoradio Android Plug&Play dedicate, disegnate per il tuo modello. Zero splicing, zero rischi.",
    footer_track_order: "Traccia il tuo ordine",
    footer_guides: "Guide",
    footer_support_hours: "Assistenza Lun-Ven 9-18",
    card_price_from: "Da",
    card_choose: "Scegli",
    card_choose_variant: "Scegli variante",
    klarna_chip_pay3: "3 rate",
    klarna_pay_prefix: "Paga in",
    klarna_pay_3: "3 rate",
    klarna_pay_suffix: "senza interessi",
    klarna_per_month: "/mese",
    klarna_no_fee: "nessuna commissione",
    klarna_learn_more: "Scopri come funziona",
    klarna_hero_title: "Paga in 3 rate senza interessi",
    klarna_hero_desc: "Dividi ogni ordine in 3 pagamenti · zero commissioni · approvazione istantanea al checkout",
    klarna_bullet_1: "Nessun interesse",
    klarna_bullet_2: "Nessuna commissione",
    klarna_bullet_3: "Approvazione soft-check",
    wl_login_hint: "Accedi per salvare i tuoi preferiti",
    wl_removed: "Rimosso dai preferiti",
    wl_added: "Aggiunto ai preferiti",
    wl_error: "Operazione non riuscita, riprova",
    wl_aria_remove: "Rimuovi dai preferiti",
    wl_aria_add: "Aggiungi ai preferiti",
    wl_in_list: "Nei preferiti",
    wl_label: "Preferiti",
    ship_free_badge: "Spedizione gratuita",
    ship_eu_badge: "Consegna EU · 3-5 giorni",
    footer_newsletter_title: "Newsletter",
    footer_newsletter_desc: "Guide gratuite e offerte esclusive sulla tua auto.",
    newsletter_placeholder: "La tua email",
    subscribe: "Iscriviti",
    footer_rights: "Tutti i diritti riservati.",

    // Policy links
    policy_refund: "Politica di rimborso",
    policy_privacy: "Privacy Policy",
    policy_terms: "Termini e condizioni",
    policy_shipping: "Politica di spedizione",
    policy_legal: "Note legali",
    policy_cookies: "Cookie Policy",
    policy_updated: "Ultimo aggiornamento",

    // Cookie banner
    cookie_title: "Utilizziamo i cookie",
    cookie_desc: "Usiamo cookie tecnici e, previo consenso, di analisi e marketing per migliorare la tua esperienza. Puoi accettarli tutti, rifiutarli o gestire le preferenze.",
    cookie_accept: "Accetta tutti",
    cookie_reject: "Rifiuta",
    cookie_customize: "Personalizza",
    cookie_save: "Salva preferenze",
    cookie_pref_necessary: "Necessari",
    cookie_pref_necessary_desc: "Cookie tecnici indispensabili per il funzionamento del sito.",
    cookie_pref_analytics: "Analitici",
    cookie_pref_analytics_desc: "Ci aiutano a capire come viene usato il sito in forma anonima.",
    cookie_pref_marketing: "Marketing",
    cookie_pref_marketing_desc: "Personalizzano le comunicazioni pubblicitarie in base ai tuoi interessi.",
    cookie_more: "Leggi la Cookie Policy",

    // Policy pages content
    refund_title: "Politica di rimborso",
    refund_intro: "In audrivio ci teniamo alla tua soddisfazione. Puoi restituire i prodotti entro 14 giorni dal ricevimento senza dover fornire alcuna motivazione, come previsto dal Codice del Consumo (D.lgs. 206/2005).",
    refund_h1: "Come richiedere un reso",
    refund_p1: "Per esercitare il diritto di recesso, inviaci una comunicazione scritta a support@audrivio.com entro 14 giorni dalla consegna. Ti forniremo tutte le istruzioni per il rientro della merce presso il nostro magazzino.",
    refund_h2: "Condizioni del prodotto",
    refund_p2: "Il prodotto deve essere restituito nella sua confezione originale, integro, con tutti gli accessori e la manualistica. Prodotti danneggiati per uso improprio non potranno essere rimborsati.",
    refund_h3: "Tempi di rimborso",
    refund_p3: "Una volta ricevuto e verificato il prodotto, provvederemo al rimborso entro 14 giorni lavorativi utilizzando lo stesso metodo di pagamento impiegato per l'acquisto (bonifico bancario, carta di credito o rimborso alla consegna).",
    refund_h4: "Spese di spedizione del reso",
    refund_p4: "Le spese di spedizione per il rientro della merce sono a carico del cliente, salvo diversi accordi in caso di prodotto difettoso o errore nella spedizione.",
    refund_h5: "Prodotti difettosi",
    refund_p5: "Se ricevi un prodotto difettoso o non conforme, contattaci immediatamente. In questi casi le spese di rientro e sostituzione sono interamente a nostro carico.",

    privacy_title: "Privacy Policy",
    privacy_intro: "La presente Privacy Policy descrive come audrivio raccoglie, utilizza e protegge i tuoi dati personali in conformità al Regolamento UE 2016/679 (GDPR) e alla normativa italiana vigente.",
    privacy_h1: "Titolare del trattamento",
    privacy_p1: "audrivio è il titolare del trattamento dei dati personali raccolti tramite il presente sito. Per qualsiasi richiesta puoi scrivere a privacy@audrivio.com.",
    privacy_h2: "Tipologie di dati raccolti",
    privacy_p2: "Raccogliamo dati anagrafici (nome, cognome), dati di contatto (email, telefono, indirizzo), dati di pagamento (gestiti in modo sicuro dai provider certificati) e dati di navigazione (indirizzo IP, cookie, dispositivo).",
    privacy_h3: "Finalità del trattamento",
    privacy_p3: "Utilizziamo i tuoi dati per: gestire ordini e spedizioni, assistenza clienti, adempimenti fiscali, invio di comunicazioni commerciali (solo previo consenso), analisi statistiche in forma anonima.",
    privacy_h4: "Diritti dell'interessato",
    privacy_p4: "Hai il diritto di accedere, rettificare, cancellare, limitare o opporti al trattamento dei tuoi dati, di richiedere la portabilità o di revocare il consenso in qualsiasi momento scrivendo a privacy@audrivio.com.",
    privacy_h5: "Conservazione dei dati",
    privacy_p5: "I dati vengono conservati per il tempo strettamente necessario alle finalità di trattamento, nel rispetto degli obblighi di legge (in genere 10 anni per obblighi fiscali).",
    privacy_h6: "Condivisione con terze parti",
    privacy_p6: "I dati non vengono venduti a terzi. Possono essere condivisi con corrieri, gateway di pagamento, provider tecnologici e autorità competenti, esclusivamente per le finalità sopra indicate.",

    terms_title: "Termini e Condizioni",
    terms_intro: "L'utilizzo del sito audrivio implica l'accettazione integrale dei presenti Termini e Condizioni di vendita. Ti invitiamo a leggerli attentamente prima di procedere con un acquisto.",
    terms_h1: "Oggetto",
    terms_p1: "I presenti termini regolano la vendita a distanza di autoradio Android Plug&Play e accessori tramite il sito audrivio, fra il venditore e l'utente consumatore ai sensi del D.lgs. 206/2005.",
    terms_h2: "Ordini e conclusione del contratto",
    terms_p2: "Il contratto si intende concluso al momento della conferma d'ordine via email da parte di audrivio. Ci riserviamo il diritto di rifiutare un ordine per motivi di disponibilità o sicurezza.",
    terms_h3: "Prezzi e pagamenti",
    terms_p3: "Tutti i prezzi sono espressi in Euro e includono l'IVA. Accettiamo pagamenti tramite carta di credito, bonifico, PayPal, Klarna (pagamento rateale) e contrassegno alla consegna dove disponibile.",
    terms_h4: "Consegna",
    terms_p4: "La consegna avviene in 24-48 ore lavorative sul territorio italiano tramite corriere espresso. Per le isole e le zone extraurbane i tempi possono estendersi fino a 5 giorni lavorativi.",
    terms_h5: "Garanzia legale",
    terms_p5: "Tutti i prodotti sono coperti da garanzia legale di conformità di 24 mesi per i consumatori, come previsto dagli artt. 128 e ss. del Codice del Consumo.",
    terms_h6: "Foro competente",
    terms_p6: "Per qualsiasi controversia sarà competente il foro del luogo di residenza o domicilio del consumatore, se ubicato in Italia; in caso contrario il foro sarà quello di Milano.",

    shipping_title: "Politica di spedizione",
    shipping_intro: "Spediamo in tutta Italia con corrieri certificati e ti forniamo il tracking in tempo reale. Ecco tutte le informazioni utili sulla nostra logistica.",
    shipping_h1: "Tempi di consegna",
    shipping_p1: "Gli ordini ricevuti entro le ore 15:00 nei giorni lavorativi vengono processati e spediti in giornata. La consegna avviene generalmente entro 24-48 ore in tutta Italia continentale.",
    shipping_h2: "Isole e zone extraurbane",
    shipping_p2: "Per Sicilia, Sardegna e piccole isole i tempi di consegna possono estendersi fino a 4-5 giorni lavorativi. Per zone extraurbane o rurali possono essere previsti giorni aggiuntivi.",
    shipping_h3: "Costi di spedizione",
    shipping_p3: "La spedizione express è gratuita per tutti gli ordini superiori a 99€. Per ordini di importo inferiore è applicato un contributo spese fisso di 9,90€.",
    shipping_h4: "Pagamento alla consegna",
    shipping_p4: "È possibile richiedere il pagamento in contrassegno (contanti alla consegna) con un supplemento di 4,90€. Servizio disponibile solo per ordini inferiori a 1.000€.",
    shipping_h5: "Tracking",
    shipping_p5: "Non appena il pacco è affidato al corriere, ricevi via email un link di tracking con cui monitorare la spedizione passo dopo passo, in tempo reale.",
    shipping_h6: "Pacchi non consegnati",
    shipping_p6: "In caso di assenza al momento della consegna, il corriere lascerà un avviso e ripasserà nei giorni successivi. Contattaci se il pacco non arriva entro 7 giorni lavorativi.",

    legal_title: "Note legali",
    legal_intro: "Le presenti note legali contengono tutte le informazioni richieste dalla normativa italiana ed europea in materia di commercio elettronico.",
    legal_h1: "Denominazione",
    legal_p1: "Il sito audrivio è gestito da audrivio con sede legale in Italia. Iscrizione al Registro Imprese e Partita IVA disponibili su richiesta scrivendo a legal@audrivio.com.",
    legal_h2: "Contatti",
    legal_p2: "Email: support@audrivio.com · WhatsApp: +39 351 129 4525 · Assistenza attiva dal lunedì al venerdì, 9:00 – 18:00.",
    legal_h3: "Proprietà intellettuale",
    legal_p3: "Tutti i contenuti presenti sul sito (testi, immagini, loghi, video, layout) sono di proprietà di audrivio o dei rispettivi titolari e sono protetti dalle leggi sul diritto d'autore.",
    legal_h4: "Limitazione di responsabilità",
    legal_p4: "audrivio si impegna a mantenere aggiornate le informazioni presenti sul sito ma non garantisce l'assenza di errori tecnici o tipografici. Le specifiche dei prodotti possono subire variazioni senza preavviso.",
    legal_h5: "Risoluzione ODR",
    legal_p5: "In conformità al Reg. UE 524/2013, i consumatori possono ricorrere alla piattaforma europea di risoluzione online delle controversie disponibile all'indirizzo ec.europa.eu/consumers/odr.",

    // Cart drawer
    cart_title: "Il tuo carrello",
    cart_empty: "Il carrello è vuoto",
    cart_empty_cta: "Sfoglia i prodotti",
    cart_subtotal: "Subtotale",
    cart_free_shipping: "Spedizione gratuita in Italia · Estero €20 · 3-5 giorni lavorativi",
    cart_checkout_btn: "Procedi al checkout",
    cart_remove: "Rimuovi",

    // Checkout — steps
    checkout_step_shipping: "Spedizione",
    checkout_step_payment: "Pagamento",
    checkout_step_review: "Riepilogo",
    checkout_title: "Checkout",
    checkout_shipping_title: "Indirizzo di spedizione",
    checkout_shipping_note: "Tutti i campi sono obbligatori per procedere con l'acquisto.",
    checkout_field_fullname: "Nome e cognome *",
    checkout_field_email: "Email *",
    checkout_field_phone: "Telefono *",
    checkout_field_city: "Città *",
    checkout_field_address: "Indirizzo (via/piazza) *",
    checkout_field_civic: "Civico *",
    checkout_field_postal: "CAP *",
    checkout_field_country: "Paese *",
    checkout_payment_title: "Metodo di pagamento",
    checkout_pay_card: "Carta di credito",
    checkout_pay_card_desc: "Pagamento sicuro tramite Stripe",
    checkout_pay_klarna: "Klarna · Paga in 3 rate",
    checkout_pay_klarna_desc: "3 rate senza interessi · Approvazione istantanea",
    checkout_pay_paypal: "PayPal",
    checkout_pay_paypal_desc: "Paga con il tuo account PayPal",
    checkout_pay_cod: "Pagamento alla consegna",
    checkout_pay_cod_desc: "+ € 10,00 costi contrassegno",
    checkout_review_title: "Riepilogo ordine",
    checkout_ship_to: "Spedizione a",
    checkout_shipping_free: "Spedizione: Gratuita",
    checkout_cod_fee: "Costi contrassegno",
    checkout_total: "Totale",
    checkout_coupon_placeholder: "Codice sconto",
    checkout_coupon_apply: "Applica",
    checkout_coupon_applied: "Codice applicato",
    checkout_coupon_invalid: "Codice non valido",
    checkout_back: "Indietro",
    checkout_next: "Continua",
    checkout_submit: "Effettua ordine",
    checkout_submitting: "Elaborazione…",
    checkout_error_fields: "Compila tutti i campi obbligatori",
    checkout_error_generic: "Si è verificato un errore, riprova.",
    checkout_secure_note: "Pagamento sicuro · Dati crittografati · IVA inclusa",
    checkout_empty_cart_desc: "Aggiungi almeno un prodotto per procedere al checkout.",
    checkout_register_title: "Crea account durante l'acquisto",
    checkout_register_desc: "Salva i tuoi dati per gli ordini futuri, traccia le spedizioni e accedi allo sconto Partner se sei un fornitore.",
    checkout_register_guest: "Continua come ospite",
    checkout_register_cta: "Registrati",
    checkout_register_success: "Account creato — dati precompilati",
    checkout_partner_note: "Sei un fornitore o partner?",
    checkout_partner_link: "Registrati qui",
    checkout_partner_suffix: "per lo sconto dedicato.",
    checkout_pay_klarna_installment: "3 rate senza interessi da",
    checkout_pay_klarna_approval: "· Approvazione istantanea",
    checkout_pay_paypal_long: "Paga con il tuo account PayPal — nessuna carta necessaria",
    checkout_qty: "Qtà:",
    checkout_payment_label: "Pagamento:",
    checkout_confirm_order: "Conferma ordine",
    checkout_summary_shipping: "Spedizione",
    checkout_summary_shipping_free: "Gratuita",
    checkout_eta_it: "Consegna in 24-48h con corriere espresso.",
    checkout_eta_foreign: "Consegna estero in 3-5 giorni lavorativi. Contrassegno non disponibile.",
    checkout_summary_cod: "Contrassegno",
    checkout_summary_discount: "Sconto",
    checkout_coupon_applied_toast: "applicato",
    checkout_coupon_error_toast: "Errore checkout",
    checkout_coupon_label: "Codice sconto",
    promo_gift_applied: "omaggi attivati! Li trovi nel carrello con un autoradio",
    promo_gift_hint: "Codice {code} attivo: aggiungi un autoradio Android (oltre € {min}) per ricevere gli omaggi gratis.",
    promo_gift_badge: "Omaggio",
    promo_gift_summary: "Omaggi inclusi",
    promo_country_blocked: "Questo codice non è valido per il paese di spedizione selezionato.",
    checkout_link_loading: "Stiamo preparando il tuo carrello…",
    checkout_phone_note: "Potremmo contattarti se non completi l'ordine.",
    save_cart_title: "Salva il carrello e ricevi assistenza su WhatsApp",
    save_cart_desc: "Lascia email o numero WhatsApp: ti mandiamo il link per completare l'ordine e rispondiamo a ogni dubbio sulla compatibilità.",
    save_cart_placeholder: "Email o numero WhatsApp",
    save_cart_btn: "Salva",
    save_cart_done: "Carrello salvato! Ti contatteremo per aiutarti a completare l'ordine.",
    save_cart_invalid: "Inserisci un'email o un numero di telefono valido",
    save_cart_consent: "Usiamo il contatto solo per questo carrello. Nessuno spam.",
    exit_title: "Aspetta! Lasci il carrello?",
    exit_desc: "Ti mandiamo il link per completarlo quando vuoi, e ti aiutiamo su WhatsApp se hai dubbi sulla compatibilità.",
    exit_btn: "Inviami il link",
    exit_dismiss: "No grazie",
    exit_done: "Fatto! Ti abbiamo salvato il carrello.",
    checkout_link_invalid: "Prodotti del link non disponibili",
    checkout_coupon_apply_short: "OK",
    checkout_back_arrow: "← Indietro",

    // Product detail page
    pdp_loading: "Caricamento…",
    pdp_back_to_catalog: "Torna al catalogo",
    pdp_reviews_suffix: "recensioni",
    pdp_variant_label: "Variante:",
    pdp_out_of_stock: "Esaurito",
    pdp_trust_warranty: "Garanzia 24 mesi",
    pdp_trust_shipping: "Spedizione 24-48h",
    pdp_trust_return: "Reso 14 giorni",
    pdp_tab_desc: "Descrizione",
    pdp_tab_specs: "Specifiche tecniche",
    pdp_tab_versions: "Versioni disponibili",
    pdp_tab_trust: "Garanzia & Spedizione",
    pdp_versions_none: "Nessuna variante disponibile.",
    pdp_version_selected: "Selezionata",
    pdp_version_select: "Seleziona",
    pdp_version_base: "Versione base",
    pdp_features_included: "Funzioni incluse",
    pdp_trust_warranty_desc: "Copertura completa su tutti i prodotti, ricambi e riparazioni.",
    pdp_trust_ship_title_long: "Spedizione 24-48h",
    pdp_trust_ship_desc: "Spediamo in tutta Italia con corriere espresso tracciato.",
    pdp_trust_return_title_long: "Reso facile 14 giorni",
    pdp_trust_return_desc: "Cambia idea? Rimborso completo entro 14 giorni.",
    pdp_related_kicker: "Completa il set",
    pdp_related_title: "Accessori consigliati",
    pdp_related_link: "Tutti gli accessori →",
    pdp_option_group_color: "Colore",
    pdp_option_group_version: "Versione",
    pdp_wa_hello: "Ciao audrivio, vorrei info su:",
    badge_sale: "In offerta",
    badge_new: "Nuovo",
    badge_best: "Best seller",
    seo_pdp_title_suffix: "· Autoradio Android",
    seo_pdp_desc_fallback: "Autoradio Android Plug&Play. Installazione 30 min, garanzia 24 mesi.",

    // Auth (login / register)
    auth_kicker_login: "Account cliente",
    auth_login_title: "Accedi",
    auth_login_desc: "Accedi al tuo account per vedere ordini, indirizzi e dati.",
    auth_field_email: "Email",
    auth_field_password: "Password",
    auth_login_cta: "Accedi",
    auth_login_loading: "Accesso…",
    auth_login_success: "Bentornato!",
    auth_login_error: "Credenziali non valide",
    auth_no_account: "Non hai un account?",
    auth_register_link: "Registrati",
    auth_kicker_register: "Nuovo account",
    auth_register_title: "Crea il tuo account audrivio",
    auth_register_desc: "Registrati come cliente per acquistare, o come fornitore/partner per accedere al listino con sconto dedicato.",
    auth_role_customer: "Cliente",
    auth_role_supplier: "Fornitore",
    auth_have_account: "Hai già un account?",
    auth_login_link: "Accedi",
    auth_benefits_title: "Vantaggi",
    auth_benefits_supplier: "Programma Partner",
    auth_benefits_customer: "Perché registrarsi",
    auth_ben_supp_1_t: "Sconto dedicato",
    auth_ben_supp_1_d: "Applicato automaticamente a ogni ordine dopo l'approvazione",
    auth_ben_supp_2_t: "Approvazione manuale",
    auth_ben_supp_2_d: "Verifichiamo P.IVA/CF in 24-48h lavorative",
    auth_ben_supp_3_t: "Priorità spedizione",
    auth_ben_supp_3_d: "Ordini partner processati per primi",
    auth_ben_cust_1_t: "Tracking ordini",
    auth_ben_cust_1_d: "Segui lo stato di ogni spedizione in tempo reale",
    auth_ben_cust_2_t: "Storico e garanzie",
    auth_ben_cust_2_d: "Ricevute e garanzia sempre a portata di mano",
    auth_ben_cust_3_t: "Sconti riservati",
    auth_ben_cust_3_d: "Codici e promozioni solo per gli iscritti",

    // Registration form
    reg_err_password_short: "La password deve avere almeno 8 caratteri",
    reg_err_password_mismatch: "Le password non coincidono",
    reg_err_company: "La ragione sociale è obbligatoria",
    reg_err_taxcode: "Codice Fiscale o P.IVA è obbligatorio per i fornitori",
    reg_err_required: "Compila tutti i campi obbligatori (contrassegnati con *)",
    reg_err_generic: "Errore di registrazione",
    reg_supplier_sent: "Richiesta inviata — ti contatteremo dopo l'approvazione",
    reg_customer_success: "Account creato — benvenuto!",
    reg_pending_title: "Richiesta ricevuta!",
    reg_pending_desc: "Il nostro team verificherà i tuoi dati aziendali e ti attiverà l'account entro 24-48 ore lavorative.",
    reg_company: "Ragione sociale *",
    reg_fullname_supplier: "Nome e cognome del referente *",
    reg_fullname_customer: "Nome e cognome *",
    reg_email: "Email *",
    reg_phone: "Telefono *",
    reg_address: "Indirizzo (via/piazza) *",
    reg_civic: "Civico *",
    reg_postal: "CAP *",
    reg_city: "Città *",
    reg_country: "Nazione *",
    reg_taxcode_required: "Codice Fiscale / Partita IVA *",
    reg_taxcode_optional: "Codice Fiscale / Partita IVA (opzionale)",
    reg_notes_label: "Attività / Note (opzionale)",
    reg_notes_placeholder: "Es. Officina specializzata in car-audio…",
    reg_password: "Password (min 8 caratteri) *",
    reg_confirm: "Conferma password *",
    reg_loading: "Creazione…",
    reg_cta_customer: "Crea account cliente",
    reg_cta_supplier: "Invia richiesta fornitore",
    reg_supplier_footnote: "La richiesta verrà verificata e approvata dal nostro team entro 24-48 ore lavorative.",
    country_IT: "Italia", country_AT: "Austria", country_BE: "Belgio",
    country_BG: "Bulgaria", country_HR: "Croazia", country_CY: "Cipro",
    country_CZ: "Repubblica Ceca", country_DK: "Danimarca", country_EE: "Estonia",
    country_FI: "Finlandia", country_FR: "Francia", country_DE: "Germania",
    country_GR: "Grecia", country_IE: "Irlanda", country_LV: "Lettonia",
    country_LT: "Lituania", country_LU: "Lussemburgo", country_MT: "Malta",
    country_NL: "Paesi Bassi", country_PL: "Polonia", country_PT: "Portogallo",
    country_RO: "Romania", country_SK: "Slovacchia", country_SI: "Slovenia",
    country_ES: "Spagna", country_SE: "Svezia", country_HU: "Ungheria",
    country_GB: "Regno Unito", country_CH: "Svizzera", country_SM: "San Marino",

    // About page
    about_seo_title: "Chi siamo · Il team audrivio",
    about_seo_desc: "Team appassionato di car-audio con oltre 10 anni di installazioni sul campo. Selezioniamo hardware Android premium e sviluppiamo firmware specifici per ogni modello.",
    about_kicker: "Chi siamo",
    about_h1: "Autoradio, con l'attenzione di un artigiano.",
    about_intro: "audrivio nasce dall'esperienza di un team appassionato di car-audio con oltre 10 anni di installazioni sul campo. Selezioniamo hardware Android premium e sviluppiamo firmware specifici per ogni modello di auto.",
    about_mission_title: "La nostra missione",
    about_mission_desc: "Rendere l'aggiornamento dell'infotainment accessibile a tutti: kit completi, tutorial e assistenza umana quando serve.",
    about_commit_title: "Il nostro impegno",
    about_commit_desc: "Ogni prodotto è testato prima della spedizione. Se qualcosa non funziona, lo risolviamo — punto.",

    // Contact page
    contact_seo_title: "Contatti audrivio",
    contact_seo_desc: "Scrivici via email, WhatsApp o modulo di contatto. Assistenza tecnica e pre-vendita dal lunedì al venerdì, 9-18.",
    contact_kicker: "Contatti",
    contact_h1: "Parliamone.",
    contact_intro: "Rispondiamo entro 15 minuti in orario lavorativo. Per assistenza tecnica preferisci WhatsApp.",
    contact_name: "Nome",
    contact_email: "Email",
    contact_message: "Messaggio",
    contact_sending: "Invio…",
    contact_send: "Invia messaggio",
    contact_success: "Messaggio inviato — ti risponderemo entro 24h",
    contact_error: "Errore invio",
    contact_support: "Assistenza",
    contact_support_hours: "Lun-Ven 9:00 – 18:00",

    // Blog page
    blog_seo_title: "Guide, installazione, novità · Blog audrivio",
    blog_seo_desc: "Guide di compatibilità autoradio Android, tutorial di installazione step-by-step e novità dal mondo car-audio. Aggiornati settimanalmente.",
    blog_kicker: "Guide & Blog",
    blog_h1: "Guide, installazione, novità.",
    blog_filter_all: "Tutte",
    blog_cat_compatibility: "Guide compatibilità",
    blog_cat_installation: "Guide installazione",
    blog_cat_news: "Novità prodotto",
    blog_read: "Leggi",
    blog_all_articles: "Tutti gli articoli",
    blog_related_products: "Prodotti correlati",

    // Track order page
    track_seo_title: "Traccia il tuo ordine",
    track_seo_desc: "Inserisci il codice di tracking per verificare lo stato del tuo ordine audrivio. Nessuna registrazione necessaria.",
    track_kicker: "Tracking",
    track_h1: "Traccia il tuo ordine",
    track_intro: "Inserisci il codice di tracking ricevuto via email al momento dell'ordine. Non serve accedere al tuo account.",
    track_code_label: "Codice di tracking",
    track_code_placeholder: "es. A1B2C3D4",
    track_email_label: "Email",
    track_email_optional: "(facoltativa)",
    track_email_placeholder: "la-tua@email.it",
    track_submit: "Traccia",
    track_searching: "Cerco…",
    track_error_short: "Inserisci un codice di almeno 6 caratteri",
    track_error_notfound: "Ordine non trovato",
    track_order_label: "Ordine",
    track_items: "articoli",
    track_payment: "Pagamento",
    track_destination: "Destinazione",
    track_courier: "Corriere",
    track_help: "Serve aiuto? Contattaci su",
    track_help_suffix: "citando il codice",
    track_status_processing: "In lavorazione",
    track_status_confirmed: "Confermato",
    track_status_shipped: "Spedito",
    track_status_delivered: "Consegnato",
    track_status_cancelled: "Annullato",
    pay_status_pending: "Pagamento in attesa",
    pay_status_paid: "Pagato",
    pay_status_refunded: "Rimborsato",

    // Checkout success page
    success_paypal_confirming_h1: "Sto confermando il tuo pagamento PayPal…",
    success_paypal_confirming_desc: "Non chiudere questa pagina, ci vogliono pochi secondi.",
    success_paypal_error_h1: "Pagamento non riuscito",
    success_paypal_error_generic: "Impossibile completare il pagamento PayPal.",
    success_paypal_error_capture: "Errore incasso PayPal.",
    success_retry_payment: "Riprova il pagamento",
    success_h1: "Ordine confermato",
    success_desc: "Grazie! Riceverai a breve un'email con i dettagli.",
    success_order_label: "Ordine",
    success_payment_status_label: "Stato pagamento:",
    success_total_label: "Totale:",
    success_email_sent: "Ti abbiamo inviato una conferma via email.",
    success_back_home: "Torna alla home",
  },

  en: {
    // Navigation
    nav_home: "Home",
    nav_catalog: "Catalog",
    nav_blog: "Guides & Blog",
    nav_about: "About",
    nav_contact: "Contact",
    nav_accessories: "Accessories",

    // Header
    header_wa_cta: "Contact us for more info",
    header_cart: "Cart",
    header_login: "Sign in",
    header_account_my: "My account",
    header_account_orders: "My orders",
    header_account_logout: "Sign out",
    header_promo: "Free express shipping 24-48h · Cash on delivery available · 24-month warranty",

    // CTAs
    cta_find: "Find your model",
    cta_catalog: "Browse catalog",
    trust_warranty: "Warranty included",
    trust_shipping: "24-48h shipping",
    trust_wa: "WhatsApp support",

    // Home hero + why + steps
    section_why: "Why choose audrivio",
    section_best: "Best sellers",
    section_sale: "On sale now",
    section_how: "How it works",
    section_reviews: "What customers say",
    hero_badge: "Plug&Play Android head units",
    hero_title: "Your cabin, finally at 2026 level.",
    hero_subtitle: "Android head units tailored to your model. Zero splicing, 30-minute install, warranty included.",
    why_kicker: "Why us",
    best_kicker: "Best sellers",
    sale_kicker: "Deals",
    how_kicker: "The process",
    reviews_kicker: "Verified reviews",
    see_all: "See all",
    see_all_sale: "See all",
    why_1_title: "24-month warranty included",
    why_1_desc: "Every audrivio head unit is covered by our warranty with English & Italian support.",
    why_2_title: "Real WhatsApp support",
    why_2_desc: "Tech team replies within 15 minutes during business hours.",
    why_3_title: "Easy Plug&Play install",
    why_3_desc: "Zero splicing. Just plug the dedicated connectors for your model.",
    why_4_title: "Easy 14-day returns",
    why_4_desc: "Changed your mind? We take it back within 14 days, shipping included.",
    step_1_title: "Pick your car",
    step_1_desc: "Brand, model and year: we show only the compatible head unit.",
    step_2_title: "Receive the full kit",
    step_2_desc: "Fascia, wiring harness, brackets and adapters — already in the box.",
    step_3_title: "Install in 30-40 minutes",
    step_3_desc: "No wire cutting. Step-by-step tutorial included in the pack.",

    // Vehicle finder
    finder_title: "Find the perfect radio for your car",
    finder_brand: "Car brand",
    finder_model: "Model",
    finder_cta: "Check compatibility",
    finder_console_title: "Find the head unit for your car",
    finder_console_sub: "SELECT BRAND · MODEL",
    finder_label_brand: "Brand",
    finder_label_model: "Model",
    finder_placeholder_brand: "Select brand",
    finder_placeholder_model_pre: "First choose the brand",
    finder_placeholder_model: "Select model",
    finder_foot_kit: "· plug&play kit",
    finder_foot_ship: "· 24-48h",
    finder_foot_warranty: "· 24 months",

    // Product / cart
    add_to_cart: "Add to cart",
    pdp_buy_now: "Buy now",
    ask_whatsapp: "Ask on WhatsApp",
    view_cart: "View cart",
    checkout: "Proceed to checkout",
    empty_cart: "Cart is empty",

    // Footer
    footer_shop: "Shop",
    footer_support: "Support",
    footer_legal: "Legal",
    footer_manage_cookies: "Manage cookies",
    footer_tagline: "Dedicated Plug&Play Android head units, designed for your specific model. Zero splicing, zero risk.",
    footer_track_order: "Track your order",
    footer_guides: "Guides",
    footer_support_hours: "Support Mon-Fri 9-6",
    card_price_from: "From",
    card_choose: "Choose",
    card_choose_variant: "Choose variant",
    klarna_chip_pay3: "Pay in 3",
    klarna_pay_prefix: "Pay in",
    klarna_pay_3: "3 installments",
    klarna_pay_suffix: "interest-free",
    klarna_per_month: "/month",
    klarna_no_fee: "no fees",
    klarna_learn_more: "See how it works",
    klarna_hero_title: "Pay in 3 interest-free installments",
    klarna_hero_desc: "Split every order into 3 payments · zero fees · instant approval at checkout",
    klarna_bullet_1: "No interest",
    klarna_bullet_2: "No fees",
    klarna_bullet_3: "Soft-check approval",
    wl_login_hint: "Sign in to save your favourites",
    wl_removed: "Removed from favourites",
    wl_added: "Added to favourites",
    wl_error: "Something went wrong, try again",
    wl_aria_remove: "Remove from favourites",
    wl_aria_add: "Add to favourites",
    wl_in_list: "In favourites",
    wl_label: "Favourites",
    ship_free_badge: "Free shipping",
    ship_eu_badge: "EU delivery · 3-5 days",
    footer_newsletter_title: "Newsletter",
    footer_newsletter_desc: "Free guides and exclusive offers for your car.",
    newsletter_placeholder: "Your email",
    subscribe: "Subscribe",
    footer_rights: "All rights reserved.",

    // Policy links
    policy_refund: "Refund policy",
    policy_privacy: "Privacy policy",
    policy_terms: "Terms & conditions",
    policy_shipping: "Shipping policy",
    policy_legal: "Legal notice",
    policy_cookies: "Cookie policy",
    policy_updated: "Last updated",

    // Cookie banner
    cookie_title: "We use cookies",
    cookie_desc: "We use technical cookies and, with your consent, analytics and marketing cookies to enhance your experience. You can accept them all, reject or manage your preferences.",
    cookie_accept: "Accept all",
    cookie_reject: "Reject",
    cookie_customize: "Customize",
    cookie_save: "Save preferences",
    cookie_pref_necessary: "Necessary",
    cookie_pref_necessary_desc: "Technical cookies essential for the website to function.",
    cookie_pref_analytics: "Analytics",
    cookie_pref_analytics_desc: "Help us understand how the site is used, anonymously.",
    cookie_pref_marketing: "Marketing",
    cookie_pref_marketing_desc: "Personalize advertising based on your interests.",
    cookie_more: "Read the Cookie Policy",

    // Policy pages
    refund_title: "Refund policy",
    refund_intro: "At audrivio, your satisfaction matters. You may return products within 14 days from delivery without providing any reason, as set out by EU consumer law.",
    refund_h1: "How to request a return",
    refund_p1: "To exercise your right of withdrawal, send us a written request to support@audrivio.com within 14 days of delivery. We will provide full instructions for returning the goods.",
    refund_h2: "Product condition",
    refund_p2: "Products must be returned in their original packaging, undamaged, with all accessories and manuals. Items damaged by improper use cannot be refunded.",
    refund_h3: "Refund timeline",
    refund_p3: "Once we receive and verify the product, we will issue the refund within 14 business days using the same payment method used for the purchase.",
    refund_h4: "Return shipping costs",
    refund_p4: "Return shipping costs are covered by the customer, unless otherwise agreed in the case of a faulty product or shipping error.",
    refund_h5: "Faulty products",
    refund_p5: "If you receive a faulty or non-conforming product, contact us immediately. In such cases return and replacement costs are entirely on us.",

    privacy_title: "Privacy policy",
    privacy_intro: "This Privacy Policy explains how audrivio collects, uses and protects your personal data in accordance with EU Regulation 2016/679 (GDPR).",
    privacy_h1: "Data controller",
    privacy_p1: "audrivio is the controller of personal data collected through this website. For any request please write to privacy@audrivio.com.",
    privacy_h2: "Types of data collected",
    privacy_p2: "We collect personal details (name, surname), contact data (email, phone, address), payment data (securely managed by certified providers) and browsing data (IP address, cookies, device).",
    privacy_h3: "Purposes of processing",
    privacy_p3: "We use your data to: manage orders and shipping, customer care, tax obligations, marketing communications (only with consent), anonymous statistical analysis.",
    privacy_h4: "Your rights",
    privacy_p4: "You have the right to access, rectify, erase, restrict or object to the processing of your data, request portability or withdraw consent at any time by writing to privacy@audrivio.com.",
    privacy_h5: "Data retention",
    privacy_p5: "Data is retained for as long as strictly necessary for the purposes of processing, in compliance with legal obligations (generally 10 years for tax purposes).",
    privacy_h6: "Sharing with third parties",
    privacy_p6: "Data is never sold. It may be shared with couriers, payment gateways, technology providers and competent authorities, only for the purposes above.",

    terms_title: "Terms & conditions",
    terms_intro: "Using the audrivio website means you fully accept these Terms and Conditions of sale. Please read them carefully before purchasing.",
    terms_h1: "Subject",
    terms_p1: "These terms regulate the distance sale of Plug&Play Android head units and accessories through audrivio, between the seller and the consumer user pursuant to EU consumer law.",
    terms_h2: "Orders and contract",
    terms_p2: "The contract is concluded when audrivio confirms the order via email. We reserve the right to reject an order due to availability or security reasons.",
    terms_h3: "Prices and payments",
    terms_p3: "All prices are in Euro and include VAT. We accept credit cards, bank transfers, PayPal, Klarna (installments) and cash on delivery where available.",
    terms_h4: "Delivery",
    terms_p4: "Delivery takes 24-48 business hours across mainland Italy via express courier. For islands and remote areas delivery may take up to 5 business days.",
    terms_h5: "Legal warranty",
    terms_p5: "All products are covered by a 24-month legal conformity warranty for consumers, as required by EU consumer law.",
    terms_h6: "Jurisdiction",
    terms_p6: "For any dispute the competent court will be that of the consumer's residence or domicile, if located in the EU; otherwise the competent court will be Milan.",

    shipping_title: "Shipping policy",
    shipping_intro: "We ship throughout Italy with certified couriers and provide real-time tracking. Here is everything you need to know about our logistics.",
    shipping_h1: "Delivery times",
    shipping_p1: "Orders placed by 3:00 PM on business days are processed and shipped the same day. Delivery typically takes 24-48 hours across mainland Italy.",
    shipping_h2: "Islands and remote areas",
    shipping_p2: "For Sicily, Sardinia and smaller islands delivery may take up to 4-5 business days. Rural or remote areas may require additional days.",
    shipping_h3: "Shipping costs",
    shipping_p3: "Express shipping is free for all orders over €99. For smaller orders a fixed shipping fee of €9.90 applies.",
    shipping_h4: "Cash on delivery",
    shipping_p4: "You can request cash on delivery for a €4.90 surcharge. Available only for orders below €1,000.",
    shipping_h5: "Tracking",
    shipping_p5: "As soon as the parcel is handed to the courier, you receive an email with a tracking link to follow the shipment step by step.",
    shipping_h6: "Undelivered parcels",
    shipping_p6: "If you are not home at delivery, the courier will leave a notice and try again. Contact us if the parcel does not arrive within 7 business days.",

    legal_title: "Legal notice",
    legal_intro: "This legal notice contains all information required by Italian and European e-commerce regulations.",
    legal_h1: "Company name",
    legal_p1: "The audrivio website is operated by audrivio, based in Italy. Business registration and VAT number available on request at legal@audrivio.com.",
    legal_h2: "Contacts",
    legal_p2: "Email: support@audrivio.com · WhatsApp: +39 351 129 4525 · Support Mon-Fri, 9:00 AM – 6:00 PM.",
    legal_h3: "Intellectual property",
    legal_p3: "All content on this website (text, images, logos, videos, layouts) is owned by audrivio or its respective owners and protected by copyright law.",
    legal_h4: "Limitation of liability",
    legal_p4: "audrivio strives to keep the site up to date but does not guarantee the absence of technical or typographical errors. Product specifications are subject to change without notice.",
    legal_h5: "ODR",
    legal_p5: "In compliance with EU Reg. 524/2013, consumers may access the European online dispute resolution platform at ec.europa.eu/consumers/odr.",

    // Cart drawer
    cart_title: "Your cart",
    cart_empty: "Your cart is empty",
    cart_empty_cta: "Browse products",
    cart_subtotal: "Subtotal",
    cart_free_shipping: "Free shipping in Italy · €20 flat EU shipping · 3-5 business days abroad",
    cart_checkout_btn: "Proceed to checkout",
    cart_remove: "Remove",

    // Checkout — steps
    checkout_step_shipping: "Shipping",
    checkout_step_payment: "Payment",
    checkout_step_review: "Review",
    checkout_title: "Checkout",
    checkout_shipping_title: "Shipping address",
    checkout_shipping_note: "All fields are required to complete your order.",
    checkout_field_fullname: "Full name *",
    checkout_field_email: "Email *",
    checkout_field_phone: "Phone *",
    checkout_field_city: "City *",
    checkout_field_address: "Street address *",
    checkout_field_civic: "Number *",
    checkout_field_postal: "ZIP *",
    checkout_field_country: "Country *",
    checkout_payment_title: "Payment method",
    checkout_pay_card: "Credit card",
    checkout_pay_card_desc: "Secure payment via Stripe",
    checkout_pay_klarna: "Klarna · Pay in 3",
    checkout_pay_klarna_desc: "3 interest-free installments · Instant approval",
    checkout_pay_paypal: "PayPal",
    checkout_pay_paypal_desc: "Pay with your PayPal account",
    checkout_pay_cod: "Cash on delivery",
    checkout_pay_cod_desc: "+ € 10.00 handling fee",
    checkout_review_title: "Order summary",
    checkout_ship_to: "Ship to",
    checkout_shipping_free: "Shipping: Free",
    checkout_cod_fee: "Cash on delivery fee",
    checkout_total: "Total",
    checkout_coupon_placeholder: "Discount code",
    checkout_coupon_apply: "Apply",
    checkout_coupon_applied: "Code applied",
    checkout_coupon_invalid: "Invalid code",
    checkout_back: "Back",
    checkout_next: "Continue",
    checkout_submit: "Place order",
    checkout_submitting: "Processing…",
    checkout_error_fields: "Please fill in all required fields",
    checkout_error_generic: "Something went wrong, please try again.",
    checkout_secure_note: "Secure payment · Encrypted data · VAT included",
    checkout_empty_cart_desc: "Add at least one product to proceed with checkout.",
    checkout_register_title: "Create an account during checkout",
    checkout_register_desc: "Save your details for future orders, track shipments and get the Partner discount if you are a supplier.",
    checkout_register_guest: "Continue as guest",
    checkout_register_cta: "Sign up",
    checkout_register_success: "Account created — details prefilled",
    checkout_partner_note: "Are you a supplier or partner?",
    checkout_partner_link: "Register here",
    checkout_partner_suffix: "for the dedicated discount.",
    checkout_pay_klarna_installment: "3 interest-free installments from",
    checkout_pay_klarna_approval: "· Instant approval",
    checkout_pay_paypal_long: "Pay with your PayPal account — no card needed",
    checkout_qty: "Qty:",
    checkout_payment_label: "Payment:",
    checkout_confirm_order: "Place order",
    checkout_summary_shipping: "Shipping",
    checkout_summary_shipping_free: "Free",
    checkout_eta_it: "Delivery in 24-48h with tracked express courier.",
    checkout_eta_foreign: "International delivery in 3-5 business days. Cash on delivery not available.",
    checkout_summary_cod: "Cash on delivery",
    checkout_summary_discount: "Discount",
    checkout_coupon_applied_toast: "applied",
    checkout_coupon_error_toast: "Checkout error",
    checkout_coupon_label: "Discount code",
    promo_gift_applied: "free gifts unlocked! They appear in your cart with a car stereo",
    promo_gift_hint: "Code {code} active: add an Android car stereo (over € {min}) to receive the free gifts.",
    promo_gift_badge: "Free gift",
    promo_gift_summary: "Free gifts included",
    promo_country_blocked: "This code is not valid for the selected shipping country.",
    checkout_link_loading: "Preparing your cart…",
    checkout_phone_note: "We may contact you if you don't complete your order.",
    save_cart_title: "Save your cart & get WhatsApp support",
    save_cart_desc: "Leave your email or WhatsApp number: we'll send you the link to complete your order and answer any compatibility question.",
    save_cart_placeholder: "Email or WhatsApp number",
    save_cart_btn: "Save",
    save_cart_done: "Cart saved! We'll get in touch to help you complete your order.",
    save_cart_invalid: "Enter a valid email or phone number",
    save_cart_consent: "We only use your contact for this cart. No spam.",
    exit_title: "Wait! Leaving your cart?",
    exit_desc: "We'll send you the link to complete it whenever you want, and help you on WhatsApp with any compatibility question.",
    exit_btn: "Send me the link",
    exit_dismiss: "No thanks",
    exit_done: "Done! Your cart has been saved.",
    checkout_link_invalid: "Products in this link are not available",
    checkout_coupon_apply_short: "OK",
    checkout_back_arrow: "← Back",

    // Product detail page
    pdp_loading: "Loading…",
    pdp_back_to_catalog: "Back to catalog",
    pdp_reviews_suffix: "reviews",
    pdp_variant_label: "Variant:",
    pdp_out_of_stock: "Out of stock",
    pdp_trust_warranty: "24-month warranty",
    pdp_trust_shipping: "24-48h shipping",
    pdp_trust_return: "14-day returns",
    pdp_tab_desc: "Description",
    pdp_tab_specs: "Technical specs",
    pdp_tab_versions: "Available versions",
    pdp_tab_trust: "Warranty & Shipping",
    pdp_versions_none: "No variants available.",
    pdp_version_selected: "Selected",
    pdp_version_select: "Select",
    pdp_version_base: "Base version",
    pdp_features_included: "Included features",
    pdp_trust_warranty_desc: "Full coverage on all products, spares and repairs.",
    pdp_trust_ship_title_long: "24-48h shipping",
    pdp_trust_ship_desc: "We ship across Italy with tracked express courier.",
    pdp_trust_return_title_long: "Easy 14-day returns",
    pdp_trust_return_desc: "Changed your mind? Full refund within 14 days.",
    pdp_related_kicker: "Complete the set",
    pdp_related_title: "Recommended accessories",
    pdp_related_link: "All accessories →",
    pdp_option_group_color: "Color",
    pdp_option_group_version: "Version",
    pdp_wa_hello: "Hi audrivio, I would like info about:",
    badge_sale: "On sale",
    badge_new: "New",
    badge_best: "Best seller",
    seo_pdp_title_suffix: "· Android head unit",
    seo_pdp_desc_fallback: "Plug&Play Android head unit. 30-minute install, 24-month warranty.",

    // Auth (login / register)
    auth_kicker_login: "Customer account",
    auth_login_title: "Sign in",
    auth_login_desc: "Sign in to your account to view orders, addresses and details.",
    auth_field_email: "Email",
    auth_field_password: "Password",
    auth_login_cta: "Sign in",
    auth_login_loading: "Signing in…",
    auth_login_success: "Welcome back!",
    auth_login_error: "Invalid credentials",
    auth_no_account: "Don't have an account?",
    auth_register_link: "Sign up",
    auth_kicker_register: "New account",
    auth_register_title: "Create your audrivio account",
    auth_register_desc: "Sign up as a customer to shop, or as a supplier/partner to access the dedicated discount list.",
    auth_role_customer: "Customer",
    auth_role_supplier: "Supplier",
    auth_have_account: "Already have an account?",
    auth_login_link: "Sign in",
    auth_benefits_title: "Benefits",
    auth_benefits_supplier: "Partner Program",
    auth_benefits_customer: "Why register",
    auth_ben_supp_1_t: "Dedicated discount",
    auth_ben_supp_1_d: "Automatically applied to every order after approval",
    auth_ben_supp_2_t: "Manual approval",
    auth_ben_supp_2_d: "We verify VAT/Tax ID within 24-48 business hours",
    auth_ben_supp_3_t: "Priority shipping",
    auth_ben_supp_3_d: "Partner orders processed first",
    auth_ben_cust_1_t: "Order tracking",
    auth_ben_cust_1_d: "Follow every shipment status in real time",
    auth_ben_cust_2_t: "History & warranty",
    auth_ben_cust_2_d: "Receipts and warranty always at hand",
    auth_ben_cust_3_t: "Exclusive discounts",
    auth_ben_cust_3_d: "Codes and promos only for members",

    // Registration form
    reg_err_password_short: "Password must be at least 8 characters",
    reg_err_password_mismatch: "Passwords do not match",
    reg_err_company: "Company name is required",
    reg_err_taxcode: "Tax ID / VAT number is required for suppliers",
    reg_err_required: "Please fill in all required fields (marked with *)",
    reg_err_generic: "Registration error",
    reg_supplier_sent: "Request sent — we will contact you after approval",
    reg_customer_success: "Account created — welcome!",
    reg_pending_title: "Request received!",
    reg_pending_desc: "Our team will verify your business details and activate your account within 24-48 business hours.",
    reg_company: "Company name *",
    reg_fullname_supplier: "Contact full name *",
    reg_fullname_customer: "Full name *",
    reg_email: "Email *",
    reg_phone: "Phone *",
    reg_address: "Street address *",
    reg_civic: "Number *",
    reg_postal: "ZIP *",
    reg_city: "City *",
    reg_country: "Country *",
    reg_taxcode_required: "Tax ID / VAT number *",
    reg_taxcode_optional: "Tax ID / VAT number (optional)",
    reg_notes_label: "Business / Notes (optional)",
    reg_notes_placeholder: "E.g. Workshop specialised in car audio…",
    reg_password: "Password (min 8 characters) *",
    reg_confirm: "Confirm password *",
    reg_loading: "Creating…",
    reg_cta_customer: "Create customer account",
    reg_cta_supplier: "Send supplier request",
    reg_supplier_footnote: "Your request will be verified and approved by our team within 24-48 business hours.",
    country_IT: "Italy", country_AT: "Austria", country_BE: "Belgium",
    country_BG: "Bulgaria", country_HR: "Croatia", country_CY: "Cyprus",
    country_CZ: "Czech Republic", country_DK: "Denmark", country_EE: "Estonia",
    country_FI: "Finland", country_FR: "France", country_DE: "Germany",
    country_GR: "Greece", country_IE: "Ireland", country_LV: "Latvia",
    country_LT: "Lithuania", country_LU: "Luxembourg", country_MT: "Malta",
    country_NL: "Netherlands", country_PL: "Poland", country_PT: "Portugal",
    country_RO: "Romania", country_SK: "Slovakia", country_SI: "Slovenia",
    country_ES: "Spain", country_SE: "Sweden", country_HU: "Hungary",
    country_GB: "United Kingdom", country_CH: "Switzerland", country_SM: "San Marino",

    // About page
    about_seo_title: "About · The audrivio team",
    about_seo_desc: "A passionate car-audio team with over 10 years of hands-on installations. We select premium Android hardware and develop firmware tailored to every car model.",
    about_kicker: "About",
    about_h1: "Car audio, crafted with the care of an artisan.",
    about_intro: "audrivio was born from a passionate car-audio team with over 10 years of hands-on installations. We select premium Android hardware and develop firmware tailored to every car model.",
    about_mission_title: "Our mission",
    about_mission_desc: "Make infotainment upgrades accessible to everyone: full kits, tutorials and human support when it matters.",
    about_commit_title: "Our commitment",
    about_commit_desc: "Every product is tested before shipping. If something is off, we fix it — end of story.",

    // Contact page
    contact_seo_title: "audrivio contacts",
    contact_seo_desc: "Reach us by email, WhatsApp or contact form. Technical and pre-sale support Monday to Friday, 9am-6pm.",
    contact_kicker: "Contact",
    contact_h1: "Let's talk.",
    contact_intro: "We reply within 15 minutes during business hours. For technical support, WhatsApp is fastest.",
    contact_name: "Name",
    contact_email: "Email",
    contact_message: "Message",
    contact_sending: "Sending…",
    contact_send: "Send message",
    contact_success: "Message sent — we'll reply within 24h",
    contact_error: "Send error",
    contact_support: "Support",
    contact_support_hours: "Mon-Fri 9:00 AM – 6:00 PM",

    // Blog page
    blog_seo_title: "Guides, installation, news · audrivio Blog",
    blog_seo_desc: "Android head unit compatibility guides, step-by-step installation tutorials and news from the car-audio world. Updated weekly.",
    blog_kicker: "Guides & Blog",
    blog_h1: "Guides, installation, news.",
    blog_filter_all: "All",
    blog_cat_compatibility: "Compatibility guides",
    blog_cat_installation: "Installation guides",
    blog_cat_news: "Product news",
    blog_read: "Read",
    blog_all_articles: "All articles",
    blog_related_products: "Related products",

    // Track order page
    track_seo_title: "Track your order",
    track_seo_desc: "Enter the tracking code to check the status of your audrivio order. No account required.",
    track_kicker: "Tracking",
    track_h1: "Track your order",
    track_intro: "Enter the tracking code you received by email when you placed your order. No account needed.",
    track_code_label: "Tracking code",
    track_code_placeholder: "e.g. A1B2C3D4",
    track_email_label: "Email",
    track_email_optional: "(optional)",
    track_email_placeholder: "your@email.com",
    track_submit: "Track",
    track_searching: "Searching…",
    track_error_short: "Please enter a code of at least 6 characters",
    track_error_notfound: "Order not found",
    track_order_label: "Order",
    track_items: "items",
    track_payment: "Payment",
    track_destination: "Destination",
    track_courier: "Courier",
    track_help: "Need help? Contact us on",
    track_help_suffix: "quoting code",
    track_status_processing: "Processing",
    track_status_confirmed: "Confirmed",
    track_status_shipped: "Shipped",
    track_status_delivered: "Delivered",
    track_status_cancelled: "Cancelled",
    pay_status_pending: "Payment pending",
    pay_status_paid: "Paid",
    pay_status_refunded: "Refunded",

    // Checkout success page
    success_paypal_confirming_h1: "Confirming your PayPal payment…",
    success_paypal_confirming_desc: "Please don't close this page, it takes a few seconds.",
    success_paypal_error_h1: "Payment failed",
    success_paypal_error_generic: "Unable to complete the PayPal payment.",
    success_paypal_error_capture: "PayPal capture error.",
    success_retry_payment: "Retry payment",
    success_h1: "Order confirmed",
    success_desc: "Thank you! You'll receive an email with the details shortly.",
    success_order_label: "Order",
    success_payment_status_label: "Payment status:",
    success_total_label: "Total:",
    success_email_sent: "We've sent you a confirmation email.",
    success_back_home: "Back to home",
  },

  fr: {
    // Navigation
    nav_home: "Accueil",
    nav_catalog: "Catalogue",
    nav_blog: "Guides & Blog",
    nav_about: "À propos",
    nav_contact: "Contact",

    // Header
    header_wa_cta: "Contactez-nous pour plus d'infos",
    header_cart: "Panier",
    header_login: "Se connecter",
    header_account_my: "Mon compte",
    header_account_orders: "Mes commandes",
    header_account_logout: "Se déconnecter",
    header_promo: "Livraison express gratuite 24-48h · Paiement à la livraison disponible · Garantie 24 mois",

    // CTAs
    cta_find: "Trouvez votre modèle",
    cta_catalog: "Voir le catalogue",
    trust_warranty: "Garantie incluse",
    trust_shipping: "Livraison 24-48h",
    trust_wa: "Support WhatsApp",

    // Home sections
    section_why: "Pourquoi choisir audrivio",
    section_best: "Meilleures ventes",
    section_sale: "En promotion",
    section_how: "Comment ça marche",
    section_reviews: "Ce que disent les clients",
    hero_badge: "Autoradios Android Plug&Play",
    hero_title: "Votre habitacle, enfin au niveau de 2026.",
    hero_subtitle: "Autoradios Android sur mesure pour votre modèle. Zéro coupe de câbles, installation en 30 minutes, garantie incluse.",
    why_kicker: "Pourquoi nous",
    best_kicker: "Meilleures ventes",
    sale_kicker: "Offres",
    how_kicker: "Le processus",
    reviews_kicker: "Avis vérifiés",
    see_all: "Voir tout",
    see_all_sale: "Voir toutes",
    why_1_title: "Garantie 24 mois incluse",
    why_1_desc: "Chaque autoradio audrivio est couvert par notre garantie officielle avec support en français et italien.",
    why_2_title: "Vraie assistance WhatsApp",
    why_2_desc: "Équipe technique qui répond en 15 minutes pendant les heures ouvrables.",
    why_3_title: "Installation facile Plug&Play",
    why_3_desc: "Aucune coupe de câbles. Il suffit de brancher les connecteurs dédiés à votre modèle.",
    why_4_title: "Retours faciles 14 jours",
    why_4_desc: "Vous changez d'avis ? Nous reprenons le produit sous 14 jours, livraison incluse.",
    step_1_title: "Choisissez votre voiture",
    step_1_desc: "Marque, modèle et année : nous ne montrons que l'autoradio compatible.",
    step_2_title: "Recevez le kit complet",
    step_2_desc: "Façade, faisceau, supports et adaptateurs — déjà dans la boîte.",
    step_3_title: "Installez en 30-40 minutes",
    step_3_desc: "Sans couper de fils. Tutoriel pas à pas inclus.",

    // Vehicle finder
    finder_title: "Trouvez l'autoradio adapté à votre voiture",
    finder_brand: "Marque",
    finder_model: "Modèle",
    finder_cta: "Vérifier la compatibilité",
    finder_console_title: "Trouvez l'autoradio pour votre voiture",
    finder_console_sub: "SÉLECTIONNER MARQUE · MODÈLE",
    finder_label_brand: "Marque",
    finder_label_model: "Modèle",
    finder_placeholder_brand: "Sélectionner une marque",
    finder_placeholder_model_pre: "Choisissez d'abord la marque",
    finder_placeholder_model: "Sélectionner un modèle",
    finder_foot_kit: "· kit plug&play",
    finder_foot_ship: "· 24-48h",
    finder_foot_warranty: "· 24 mois",

    // Product / cart
    add_to_cart: "Ajouter au panier",
    ask_whatsapp: "Demander sur WhatsApp",
    view_cart: "Voir le panier",
    checkout: "Passer commande",
    empty_cart: "Le panier est vide",

    // Footer
    footer_shop: "Boutique",
    footer_support: "Assistance",
    footer_legal: "Mentions légales",
    footer_manage_cookies: "Gérer les cookies",
    footer_newsletter_title: "Newsletter",
    footer_newsletter_desc: "Guides gratuits et offres exclusives pour votre voiture.",
    newsletter_placeholder: "Votre e-mail",
    subscribe: "S'inscrire",
    footer_rights: "Tous droits réservés.",

    // Policy links
    policy_refund: "Politique de remboursement",
    policy_privacy: "Politique de confidentialité",
    policy_terms: "Conditions générales",
    policy_shipping: "Politique de livraison",
    policy_legal: "Mentions légales",
    policy_cookies: "Politique des cookies",
    policy_updated: "Dernière mise à jour",

    // Cookie banner
    cookie_title: "Nous utilisons des cookies",
    cookie_desc: "Nous utilisons des cookies techniques et, avec votre consentement, des cookies d'analyse et de marketing pour améliorer votre expérience. Vous pouvez tout accepter, refuser ou gérer vos préférences.",
    cookie_accept: "Tout accepter",
    cookie_reject: "Refuser",
    cookie_customize: "Personnaliser",
    cookie_save: "Enregistrer les préférences",
    cookie_pref_necessary: "Nécessaires",
    cookie_pref_necessary_desc: "Cookies techniques indispensables au fonctionnement du site.",
    cookie_pref_analytics: "Analytiques",
    cookie_pref_analytics_desc: "Nous aident à comprendre l'utilisation du site de manière anonyme.",
    cookie_pref_marketing: "Marketing",
    cookie_pref_marketing_desc: "Personnalisent la publicité selon vos intérêts.",
    cookie_more: "Lire la politique des cookies",

    // Policy pages
    refund_title: "Politique de remboursement",
    refund_intro: "Chez audrivio, votre satisfaction compte. Vous pouvez retourner les produits sous 14 jours à compter de la livraison sans avoir à fournir de motif, conformément au droit européen de la consommation.",
    refund_h1: "Comment demander un retour",
    refund_p1: "Pour exercer votre droit de rétractation, envoyez-nous une demande écrite à support@audrivio.com sous 14 jours après la livraison. Nous vous fournirons toutes les instructions pour retourner la marchandise.",
    refund_h2: "État du produit",
    refund_p2: "Le produit doit être retourné dans son emballage d'origine, intact, avec tous les accessoires et manuels. Les articles endommagés par un usage inapproprié ne pourront pas être remboursés.",
    refund_h3: "Délais de remboursement",
    refund_p3: "Une fois le produit reçu et vérifié, nous procéderons au remboursement sous 14 jours ouvrés en utilisant le même mode de paiement que l'achat.",
    refund_h4: "Frais de retour",
    refund_p4: "Les frais de retour sont à la charge du client, sauf accord contraire en cas de produit défectueux ou d'erreur d'expédition.",
    refund_h5: "Produits défectueux",
    refund_p5: "Si vous recevez un produit défectueux ou non conforme, contactez-nous immédiatement. Les frais de retour et de remplacement sont alors entièrement à notre charge.",
    refund_h6: "Cadeaux promotionnels",
    refund_p6: "Les cadeaux reçus via un code promo doivent être retournés intacts avec l'autoradio en cas de rétractation ou de retour ; à défaut, leur prix catalogue pourra être déduit du remboursement. Les cadeaux ne sont pas convertibles en argent.",

    privacy_title: "Politique de confidentialité",
    privacy_intro: "Cette Politique de confidentialité décrit comment audrivio collecte, utilise et protège vos données personnelles conformément au Règlement UE 2016/679 (RGPD).",
    privacy_h1: "Responsable du traitement",
    privacy_p1: "audrivio est le responsable du traitement des données personnelles collectées via ce site. Pour toute demande, écrivez à privacy@audrivio.com.",
    privacy_h2: "Types de données collectées",
    privacy_p2: "Nous collectons des données d'identité (nom, prénom), de contact (e-mail, téléphone, adresse), de paiement (gérées de manière sécurisée par des prestataires certifiés) et de navigation (adresse IP, cookies, appareil).",
    privacy_h3: "Finalités du traitement",
    privacy_p3: "Nous utilisons vos données pour : gérer les commandes et les livraisons, le service client, les obligations fiscales, l'envoi de communications commerciales (uniquement avec votre consentement) et l'analyse statistique anonyme.",
    privacy_h4: "Vos droits",
    privacy_p4: "Vous avez le droit d'accéder, de rectifier, d'effacer, de limiter ou de vous opposer au traitement de vos données, de demander la portabilité ou de retirer votre consentement à tout moment en écrivant à privacy@audrivio.com.",
    privacy_h5: "Conservation des données",
    privacy_p5: "Les données sont conservées pendant la durée strictement nécessaire aux finalités du traitement, dans le respect des obligations légales (généralement 10 ans à des fins fiscales).",
    privacy_h6: "Partage avec des tiers",
    privacy_p6: "Vos données ne sont jamais vendues. Elles peuvent être partagées avec les transporteurs, les prestataires de paiement, les fournisseurs technologiques et les autorités compétentes, uniquement pour les finalités indiquées ci-dessus.",

    terms_title: "Conditions générales",
    terms_intro: "L'utilisation du site audrivio implique l'acceptation intégrale des présentes Conditions générales de vente. Nous vous invitons à les lire attentivement avant tout achat.",
    terms_h1: "Objet",
    terms_p1: "Les présentes conditions régissent la vente à distance d'autoradios Android Plug&Play et d'accessoires via audrivio, entre le vendeur et l'utilisateur consommateur conformément au droit européen de la consommation.",
    terms_h2: "Commandes et contrat",
    terms_p2: "Le contrat est réputé conclu au moment de la confirmation de la commande par e-mail par audrivio. Nous nous réservons le droit de refuser une commande pour des raisons de disponibilité ou de sécurité.",
    terms_h3: "Prix et paiements",
    terms_p3: "Tous les prix sont exprimés en euros et incluent la TVA. Nous acceptons les cartes de crédit, virements bancaires, PayPal, Klarna (paiement en plusieurs fois) et le paiement à la livraison là où il est disponible.",
    terms_h4: "Livraison",
    terms_p4: "La livraison s'effectue en 24-48 heures ouvrées sur le territoire italien via transporteur express. Pour les îles et les zones éloignées, les délais peuvent atteindre 5 jours ouvrés.",
    terms_h5: "Garantie légale",
    terms_p5: "Tous les produits sont couverts par la garantie légale de conformité de 24 mois pour les consommateurs, conformément au droit européen de la consommation.",
    terms_h6: "Juridiction compétente",
    terms_p6: "Pour tout litige, le tribunal compétent sera celui du lieu de résidence ou de domicile du consommateur, s'il est situé dans l'UE ; à défaut, le tribunal compétent sera celui de Milan.",
    terms_h7: "Promotions avec produits offerts",
    terms_p7: "Les produits offerts (ex. micro externe, caméra de recul) liés à un code promo sont ajoutés gratuitement uniquement à l'achat d'un autoradio Android éligible (prix supérieur à 150 €), dans la limite des stocks et de la validité du code (durée, nombre d'utilisations, pays). Ils n'ont pas de valeur commerciale dans la commande, ne sont pas convertibles en argent ni cumulables avec d'autres codes.",

    shipping_title: "Politique de livraison",
    shipping_intro: "Nous livrons dans toute l'Italie avec des transporteurs certifiés et fournissons un suivi en temps réel. Voici tout ce qu'il faut savoir sur notre logistique.",
    shipping_h1: "Délais de livraison",
    shipping_p1: "Les commandes reçues avant 15h00 les jours ouvrés sont traitées et expédiées dans la journée. La livraison a lieu généralement sous 24-48 heures en Italie continentale.",
    shipping_h2: "Îles et zones éloignées",
    shipping_p2: "Pour la Sicile, la Sardaigne et les petites îles, les délais peuvent atteindre 4-5 jours ouvrés. Les zones rurales ou éloignées peuvent nécessiter des jours supplémentaires.",
    shipping_h3: "Frais de livraison",
    shipping_p3: "La livraison express est gratuite pour toute commande supérieure à 99€. Pour les commandes inférieures, une participation forfaitaire de 9,90€ s'applique.",
    shipping_h4: "Paiement à la livraison",
    shipping_p4: "Vous pouvez demander le paiement à la livraison (contre-remboursement) moyennant un supplément de 4,90€. Service disponible uniquement pour les commandes inférieures à 1 000€.",
    shipping_h5: "Suivi",
    shipping_p5: "Dès que le colis est confié au transporteur, vous recevez par e-mail un lien de suivi pour surveiller l'expédition étape par étape, en temps réel.",
    shipping_h6: "Colis non livrés",
    shipping_p6: "En cas d'absence lors de la livraison, le transporteur laissera un avis et repassera les jours suivants. Contactez-nous si le colis n'arrive pas sous 7 jours ouvrés.",

    legal_title: "Mentions légales",
    legal_intro: "Les présentes mentions légales contiennent toutes les informations requises par la réglementation italienne et européenne en matière de commerce électronique.",
    legal_h1: "Dénomination",
    legal_p1: "Le site audrivio est exploité par audrivio, ayant son siège en Italie. L'inscription au Registre des Entreprises et le numéro de TVA sont disponibles sur demande à legal@audrivio.com.",
    legal_h2: "Contacts",
    legal_p2: "E-mail : support@audrivio.com · WhatsApp : +39 351 129 4525 · Assistance du lundi au vendredi, 9h – 18h.",
    legal_h3: "Propriété intellectuelle",
    legal_p3: "Tous les contenus présents sur le site (textes, images, logos, vidéos, mise en page) sont la propriété d'audrivio ou de leurs titulaires respectifs et sont protégés par le droit d'auteur.",
    legal_h4: "Limitation de responsabilité",
    legal_p4: "audrivio s'efforce de maintenir les informations du site à jour mais ne garantit pas l'absence d'erreurs techniques ou typographiques. Les spécifications des produits peuvent être modifiées sans préavis.",
    legal_h5: "Règlement des litiges (RLL)",
    legal_p5: "Conformément au Règl. UE 524/2013, les consommateurs peuvent recourir à la plateforme européenne de règlement en ligne des litiges disponible à l'adresse ec.europa.eu/consumers/odr.",
  },

  de: {
    // Navigation
    nav_home: "Startseite",
    nav_catalog: "Katalog",
    nav_blog: "Ratgeber & Blog",
    nav_about: "Über uns",
    nav_contact: "Kontakt",
    ship_free_badge: "Kostenloser Versand",
    ship_eu_badge: "EU-Lieferung · 3-5 Tage",

    // Header
    header_wa_cta: "Kontaktieren Sie uns für mehr Infos",
    header_cart: "Warenkorb",
    header_login: "Anmelden",
    header_account_my: "Mein Konto",
    header_account_orders: "Meine Bestellungen",
    header_account_logout: "Abmelden",
    header_promo: "Kostenloser Expressversand 24-48h · Zahlung bei Lieferung möglich · 24 Monate Garantie",

    // CTAs
    cta_find: "Ihr Modell finden",
    cta_catalog: "Zum Katalog",
    trust_warranty: "Garantie inklusive",
    trust_shipping: "Versand 24-48h",
    trust_wa: "WhatsApp-Support",

    // Home sections
    section_why: "Warum audrivio wählen",
    section_best: "Bestseller",
    section_sale: "Jetzt im Angebot",
    section_how: "So funktioniert's",
    section_reviews: "Was Kunden sagen",
    hero_badge: "Plug&Play Android-Autoradios",
    hero_title: "Ihr Innenraum, endlich auf dem Stand von 2026.",
    hero_subtitle: "Android-Autoradios maßgeschneidert für Ihr Modell. Kein Kabelschneiden, 30-Minuten-Einbau, Garantie inklusive.",
    why_kicker: "Warum wir",
    best_kicker: "Bestseller",
    sale_kicker: "Angebote",
    how_kicker: "Der Ablauf",
    reviews_kicker: "Geprüfte Bewertungen",
    see_all: "Alle ansehen",
    see_all_sale: "Alle ansehen",
    why_1_title: "24 Monate Garantie inklusive",
    why_1_desc: "Jedes audrivio-Autoradio ist durch unsere offizielle Garantie abgedeckt, mit Support auf Deutsch und Italienisch.",
    why_2_title: "Echter WhatsApp-Support",
    why_2_desc: "Tech-Team antwortet innerhalb von 15 Minuten während der Geschäftszeiten.",
    why_3_title: "Einfacher Plug&Play-Einbau",
    why_3_desc: "Kein Kabelschneiden. Einfach die für Ihr Modell vorgesehenen Stecker anschließen.",
    why_4_title: "14 Tage einfache Rückgabe",
    why_4_desc: "Meinung geändert? Wir nehmen das Produkt innerhalb von 14 Tagen zurück, Versand inklusive.",
    step_1_title: "Wählen Sie Ihr Auto",
    step_1_desc: "Marke, Modell und Baujahr: Wir zeigen nur das kompatible Autoradio.",
    step_2_title: "Erhalten Sie das Komplett-Kit",
    step_2_desc: "Blende, Kabelbaum, Halterungen und Adapter — bereits in der Box.",
    step_3_title: "Einbau in 30-40 Minuten",
    step_3_desc: "Kein Schneiden von Kabeln. Schritt-für-Schritt-Anleitung liegt bei.",

    // Vehicle finder
    finder_title: "Finden Sie das passende Autoradio für Ihr Auto",
    finder_brand: "Marke",
    finder_model: "Modell",
    finder_cta: "Kompatibilität prüfen",
    finder_console_title: "Autoradio für Ihr Auto finden",
    finder_console_sub: "MARKE · MODELL WÄHLEN",
    finder_label_brand: "Marke",
    finder_label_model: "Modell",
    finder_placeholder_brand: "Marke auswählen",
    finder_placeholder_model_pre: "Zuerst Marke wählen",
    finder_placeholder_model: "Modell auswählen",
    finder_foot_kit: "· plug&play-Kit",
    finder_foot_ship: "· 24-48h",
    finder_foot_warranty: "· 24 Monate",

    // Product / cart
    add_to_cart: "In den Warenkorb",
    pdp_buy_now: "Jetzt kaufen",
    ask_whatsapp: "Auf WhatsApp fragen",
    view_cart: "Warenkorb ansehen",
    checkout: "Zur Kasse",
    empty_cart: "Der Warenkorb ist leer",

    // Footer
    footer_shop: "Shop",
    footer_support: "Support",
    footer_legal: "Rechtliches",
    footer_manage_cookies: "Cookies verwalten",
    footer_newsletter_title: "Newsletter",
    footer_newsletter_desc: "Kostenlose Ratgeber und exklusive Angebote für Ihr Auto.",
    newsletter_placeholder: "Ihre E-Mail",
    subscribe: "Abonnieren",
    footer_rights: "Alle Rechte vorbehalten.",

    // Policy links
    policy_refund: "Rückerstattungsrichtlinie",
    policy_privacy: "Datenschutzerklärung",
    policy_terms: "AGB",
    policy_shipping: "Versandbedingungen",
    policy_legal: "Impressum",
    policy_cookies: "Cookie-Richtlinie",
    policy_updated: "Letzte Aktualisierung",

    // Cookie banner
    cookie_title: "Wir verwenden Cookies",
    cookie_desc: "Wir verwenden technische Cookies und mit Ihrer Zustimmung Analyse- und Marketing-Cookies, um Ihre Erfahrung zu verbessern. Sie können alle akzeptieren, ablehnen oder Ihre Präferenzen verwalten.",
    cookie_accept: "Alle akzeptieren",
    cookie_reject: "Ablehnen",
    cookie_customize: "Anpassen",
    cookie_save: "Präferenzen speichern",
    cookie_pref_necessary: "Notwendig",
    cookie_pref_necessary_desc: "Technische Cookies, die für die Funktion der Website unerlässlich sind.",
    cookie_pref_analytics: "Analyse",
    cookie_pref_analytics_desc: "Helfen uns anonym zu verstehen, wie die Website genutzt wird.",
    cookie_pref_marketing: "Marketing",
    cookie_pref_marketing_desc: "Personalisieren Werbung basierend auf Ihren Interessen.",
    cookie_more: "Cookie-Richtlinie lesen",

    // Policy pages
    refund_title: "Rückerstattungsrichtlinie",
    refund_intro: "Bei audrivio ist uns Ihre Zufriedenheit wichtig. Sie können Produkte innerhalb von 14 Tagen nach Erhalt ohne Angabe von Gründen zurückgeben, wie es das europäische Verbraucherrecht vorsieht.",
    refund_h1: "Wie fordern Sie eine Rückgabe an?",
    refund_p1: "Um Ihr Widerrufsrecht auszuüben, senden Sie uns eine schriftliche Anfrage an support@audrivio.com innerhalb von 14 Tagen nach der Lieferung. Wir teilen Ihnen alle Anweisungen für die Rücksendung mit.",
    refund_h2: "Zustand des Produkts",
    refund_p2: "Das Produkt muss in seiner Originalverpackung, unbeschädigt, mit allem Zubehör und Handbüchern zurückgesendet werden. Durch unsachgemäßen Gebrauch beschädigte Artikel können nicht erstattet werden.",
    refund_h3: "Rückerstattungsfristen",
    refund_p3: "Nach Erhalt und Prüfung des Produkts erstatten wir innerhalb von 14 Werktagen mit derselben Zahlungsmethode wie beim Kauf.",
    refund_h4: "Rücksendekosten",
    refund_p4: "Die Rücksendekosten trägt der Kunde, sofern nichts anderes vereinbart ist, z. B. bei defekten Produkten oder Versandfehlern.",
    refund_h5: "Defekte Produkte",
    refund_p5: "Wenn Sie ein defektes oder nicht konformes Produkt erhalten, kontaktieren Sie uns sofort. In diesen Fällen tragen wir die Kosten für Rücksendung und Ersatz vollständig.",
    refund_h6: "Gratis-Geschenke aus Aktionen",
    refund_p6: "Über einen Aktionscode erhaltene Gratis-Geschenke müssen bei Widerruf oder Rückgabe des Autoradios unbeschädigt mit zurückgesendet werden; andernfalls kann ihr Listenpreis von der Erstattung abgezogen werden. Geschenke sind nicht in Geld umtauschbar.",

    privacy_title: "Datenschutzerklärung",
    privacy_intro: "Diese Datenschutzerklärung beschreibt, wie audrivio Ihre personenbezogenen Daten im Einklang mit der EU-Verordnung 2016/679 (DSGVO) erhebt, verwendet und schützt.",
    privacy_h1: "Verantwortlicher",
    privacy_p1: "audrivio ist der Verantwortliche für die über diese Website erhobenen personenbezogenen Daten. Bei Fragen schreiben Sie bitte an privacy@audrivio.com.",
    privacy_h2: "Erhobene Datenkategorien",
    privacy_p2: "Wir erheben Stammdaten (Vor- und Nachname), Kontaktdaten (E-Mail, Telefon, Adresse), Zahlungsdaten (sicher verwaltet durch zertifizierte Anbieter) und Nutzungsdaten (IP-Adresse, Cookies, Gerät).",
    privacy_h3: "Zwecke der Verarbeitung",
    privacy_p3: "Wir verwenden Ihre Daten für: Bestell- und Versandabwicklung, Kundenservice, steuerliche Pflichten, kommerzielle Kommunikation (nur mit Einwilligung), anonyme statistische Auswertung.",
    privacy_h4: "Ihre Rechte",
    privacy_p4: "Sie haben das Recht, jederzeit auf Ihre Daten zuzugreifen, sie zu berichtigen, zu löschen, einzuschränken, ihrer Verarbeitung zu widersprechen, Portabilität zu verlangen oder die Einwilligung zu widerrufen — schreiben Sie an privacy@audrivio.com.",
    privacy_h5: "Speicherdauer",
    privacy_p5: "Die Daten werden nur so lange gespeichert, wie es für die Zwecke der Verarbeitung erforderlich ist, unter Einhaltung gesetzlicher Pflichten (in der Regel 10 Jahre für steuerliche Zwecke).",
    privacy_h6: "Weitergabe an Dritte",
    privacy_p6: "Ihre Daten werden nicht verkauft. Sie können an Kuriere, Zahlungsdienstleister, Technologieanbieter und zuständige Behörden ausschließlich zu den oben genannten Zwecken weitergegeben werden.",

    terms_title: "Allgemeine Geschäftsbedingungen",
    terms_intro: "Die Nutzung der audrivio-Website bedeutet die vollständige Annahme dieser Verkaufsbedingungen. Bitte lesen Sie sie vor jedem Kauf sorgfältig.",
    terms_h1: "Gegenstand",
    terms_p1: "Diese Bedingungen regeln den Fernabsatz von Plug&Play Android-Autoradios und Zubehör über audrivio zwischen Verkäufer und Verbraucher gemäß europäischem Verbraucherrecht.",
    terms_h2: "Bestellungen und Vertragsschluss",
    terms_p2: "Der Vertrag gilt als geschlossen mit der Auftragsbestätigung per E-Mail durch audrivio. Wir behalten uns das Recht vor, eine Bestellung aus Gründen der Verfügbarkeit oder Sicherheit abzulehnen.",
    terms_h3: "Preise und Zahlungen",
    terms_p3: "Alle Preise sind in Euro angegeben und enthalten die MwSt. Wir akzeptieren Kreditkarten, Überweisungen, PayPal, Klarna (Ratenzahlung) und Nachnahme, wo verfügbar.",
    terms_h4: "Lieferung",
    terms_p4: "Die Lieferung erfolgt innerhalb von 24-48 Werkstunden auf dem italienischen Festland per Expresskurier. Für Inseln und abgelegene Gebiete kann die Lieferung bis zu 5 Werktage dauern.",
    terms_h5: "Gesetzliche Gewährleistung",
    terms_p5: "Alle Produkte sind durch eine gesetzliche Konformitätsgewährleistung von 24 Monaten für Verbraucher abgedeckt, wie im europäischen Verbraucherrecht vorgesehen.",
    terms_h6: "Gerichtsstand",
    terms_p6: "Für Streitigkeiten ist das Gericht des Wohn- oder Aufenthaltsorts des Verbrauchers zuständig, sofern in der EU; ansonsten Mailand.",
    terms_h7: "Aktionen mit Gratis-Produkten",
    terms_p7: "Gratis-Produkte (z. B. externes Mikrofon, Rückfahrkamera), die an einen Aktionscode gebunden sind, werden nur beim Kauf eines berechtigten Android-Autoradios (Preis über 150 €) kostenlos hinzugefügt – solange der Vorrat reicht und im Rahmen der Gültigkeit des Codes (Laufzeit, Anzahl der Nutzungen, Länder). Sie haben im Auftrag keinen Handelswert, sind nicht in Geld umtauschbar und nicht mit anderen Codes kombinierbar.",

    shipping_title: "Versandbedingungen",
    shipping_intro: "Wir versenden italienweit mit zertifizierten Kurieren und bieten Echtzeit-Tracking. Hier finden Sie alle Infos zu unserer Logistik.",
    shipping_h1: "Lieferzeiten",
    shipping_p1: "Bestellungen, die bis 15:00 Uhr an Werktagen eingehen, werden am selben Tag bearbeitet und versendet. Die Lieferung erfolgt in der Regel innerhalb von 24-48 Stunden auf dem italienischen Festland.",
    shipping_h2: "Inseln und abgelegene Gebiete",
    shipping_p2: "Für Sizilien, Sardinien und kleinere Inseln kann die Lieferung bis zu 4-5 Werktage dauern. Ländliche oder abgelegene Gebiete können zusätzliche Tage erfordern.",
    shipping_h3: "Versandkosten",
    shipping_p3: "Expressversand ist bei allen Bestellungen über 99€ kostenlos. Für kleinere Bestellungen gilt eine pauschale Versandkostenbeteiligung von 9,90€.",
    shipping_h4: "Nachnahme",
    shipping_p4: "Nachnahme ist gegen einen Aufpreis von 4,90€ möglich. Nur für Bestellungen unter 1.000€ verfügbar.",
    shipping_h5: "Sendungsverfolgung",
    shipping_p5: "Sobald das Paket dem Kurier übergeben wird, erhalten Sie per E-Mail einen Tracking-Link, um die Sendung Schritt für Schritt in Echtzeit zu verfolgen.",
    shipping_h6: "Nicht zugestellte Pakete",
    shipping_p6: "Wenn Sie bei der Zustellung nicht zu Hause sind, hinterlässt der Kurier eine Benachrichtigung und versucht es an den folgenden Tagen erneut. Kontaktieren Sie uns, wenn das Paket nicht innerhalb von 7 Werktagen ankommt.",

    legal_title: "Impressum",
    legal_intro: "Dieses Impressum enthält alle nach italienischem und europäischem E-Commerce-Recht erforderlichen Angaben.",
    legal_h1: "Firmenbezeichnung",
    legal_p1: "Die audrivio-Website wird von audrivio mit Sitz in Italien betrieben. Handelsregister- und Umsatzsteuernummer sind auf Anfrage unter legal@audrivio.com erhältlich.",
    legal_h2: "Kontakt",
    legal_p2: "E-Mail: support@audrivio.com · WhatsApp: +39 351 129 4525 · Support Mo-Fr, 9:00 – 18:00 Uhr.",
    legal_h3: "Geistiges Eigentum",
    legal_p3: "Alle Inhalte auf dieser Website (Texte, Bilder, Logos, Videos, Layouts) sind Eigentum von audrivio oder der jeweiligen Rechteinhaber und urheberrechtlich geschützt.",
    legal_h4: "Haftungsbeschränkung",
    legal_p4: "audrivio bemüht sich, die Website aktuell zu halten, kann jedoch keine Freiheit von technischen oder typografischen Fehlern garantieren. Produktspezifikationen können sich ohne Ankündigung ändern.",
    legal_h5: "ODR",
    legal_p5: "Gemäß EU-VO 524/2013 können Verbraucher die europäische Online-Streitbeilegungsplattform unter ec.europa.eu/consumers/odr nutzen.",

    // === Fase 1 · Cart drawer ===
    cart_title: "Warenkorb",
    cart_empty: "Der Warenkorb ist leer",
    cart_empty_cta: "Zum Katalog",
    cart_subtotal: "Zwischensumme",
    cart_remove: "Entfernen",
    cart_free_shipping: "Kostenloser Versand in Italien · €20 EU-Versand · 3-5 Werktage im Ausland",
    cart_checkout_btn: "Zur Kasse",

    // === Fase 1 · Checkout ===
    checkout_title: "Kasse",
    checkout_shipping_title: "Lieferadresse",
    checkout_payment_title: "Zahlungsart",
    checkout_review_title: "Bestellübersicht",
    checkout_next: "Weiter",
    checkout_submitting: "Wird verarbeitet…",
    checkout_step_shipping: "Versand",
    checkout_step_payment: "Zahlung",
    checkout_step_review: "Übersicht",
    checkout_coupon_applied: "Code angewendet",
    checkout_coupon_invalid: "Ungültiger Code",
    checkout_total: "Gesamt",
    checkout_ship_to: "Lieferung an",
    checkout_pay_card: "Kreditkarte",
    checkout_pay_card_desc: "Sichere Zahlung über Stripe",
    checkout_pay_klarna: "Klarna · In 3 Raten",
    checkout_pay_paypal: "PayPal",
    checkout_pay_cod: "Zahlung bei Lieferung",
    checkout_pay_cod_desc: "+ € 10,00 Nachnahmegebühr",
    checkout_shipping_note: "Alle Felder sind Pflichtfelder, um mit dem Kauf fortzufahren.",
    checkout_error_fields: "Bitte füllen Sie alle Pflichtfelder aus",
    checkout_error_generic: "Etwas ist schiefgegangen, bitte erneut versuchen.",
    checkout_secure_note: "Sichere Zahlung · Verschlüsselte Daten · inkl. MwSt.",
    checkout_empty_cart_desc: "Fügen Sie mindestens ein Produkt hinzu, um zur Kasse zu gehen.",
    checkout_register_title: "Konto während des Kaufs erstellen",
    checkout_register_desc: "Speichern Sie Ihre Daten für zukünftige Bestellungen, verfolgen Sie Sendungen und erhalten Sie den Partner-Rabatt, wenn Sie Händler sind.",
    checkout_register_guest: "Als Gast fortfahren",
    checkout_register_cta: "Registrieren",
    checkout_register_success: "Konto erstellt — Daten vorausgefüllt",
    checkout_partner_note: "Sind Sie Lieferant oder Partner?",
    checkout_partner_link: "Hier registrieren",
    checkout_partner_suffix: "für den exklusiven Rabatt.",
    checkout_pay_klarna_installment: "3 zinsfreie Raten ab",
    checkout_pay_klarna_approval: "· Sofortige Genehmigung",
    checkout_pay_paypal_long: "Mit Ihrem PayPal-Konto zahlen — keine Karte nötig",
    checkout_qty: "Menge:",
    checkout_payment_label: "Zahlung:",
    checkout_confirm_order: "Bestellung aufgeben",
    checkout_summary_shipping: "Versand",
    checkout_summary_shipping_free: "Kostenlos",
    checkout_eta_it: "Lieferung in 24-48h per verfolgtem Expresskurier.",
    checkout_eta_foreign: "Internationale Lieferung in 3-5 Werktagen. Nachnahme nicht verfügbar.",
    checkout_summary_cod: "Nachnahme",
    checkout_summary_discount: "Rabatt",
    checkout_coupon_applied_toast: "angewendet",
    checkout_coupon_error_toast: "Kassen-Fehler",
    checkout_coupon_label: "Rabattcode",
    promo_gift_applied: "Gratis-Geschenke aktiviert! Sie erscheinen mit einem Autoradio im Warenkorb",
    promo_gift_hint: "Code {code} aktiv: Füge ein Android-Autoradio (über € {min}) hinzu, um die Gratis-Geschenke zu erhalten.",
    promo_gift_badge: "Geschenk",
    promo_gift_summary: "Gratis-Geschenke inklusive",
    promo_country_blocked: "Dieser Code gilt nicht für das gewählte Lieferland.",
    checkout_link_loading: "Dein Warenkorb wird vorbereitet…",
    checkout_phone_note: "Wir können dich kontaktieren, falls du die Bestellung nicht abschließt.",
    save_cart_title: "Warenkorb speichern & WhatsApp-Support erhalten",
    save_cart_desc: "Hinterlasse deine E-Mail oder WhatsApp-Nummer: Wir senden dir den Link zum Abschließen und beantworten alle Fragen zur Kompatibilität.",
    save_cart_placeholder: "E-Mail oder WhatsApp-Nummer",
    save_cart_btn: "Speichern",
    save_cart_done: "Warenkorb gespeichert! Wir melden uns, um dir beim Abschluss zu helfen.",
    save_cart_invalid: "Gib eine gültige E-Mail oder Telefonnummer ein",
    save_cart_consent: "Wir nutzen deinen Kontakt nur für diesen Warenkorb. Kein Spam.",
    exit_title: "Warte! Verlässt du deinen Warenkorb?",
    exit_desc: "Wir senden dir den Link, um ihn jederzeit abzuschließen, und helfen dir per WhatsApp bei Fragen zur Kompatibilität.",
    exit_btn: "Link zusenden",
    exit_dismiss: "Nein danke",
    exit_done: "Erledigt! Dein Warenkorb wurde gespeichert.",
    checkout_link_invalid: "Produkte aus diesem Link sind nicht verfügbar",
    checkout_coupon_apply_short: "OK",
    checkout_back_arrow: "← Zurück",

    // === Fase 1 · Product detail ===
    pdp_loading: "Wird geladen…",
    pdp_back_to_catalog: "Zurück zum Katalog",
    pdp_reviews_suffix: "Bewertungen",
    pdp_variant_label: "Variante:",
    pdp_out_of_stock: "Ausverkauft",
    pdp_trust_warranty: "24 Monate Garantie",
    pdp_trust_shipping: "Versand 24-48h",
    pdp_trust_return: "14 Tage Rückgabe",
    pdp_tab_desc: "Beschreibung",
    pdp_tab_specs: "Technische Daten",
    pdp_tab_versions: "Verfügbare Versionen",
    pdp_tab_trust: "Garantie & Versand",
    pdp_versions_none: "Keine Varianten verfügbar.",
    pdp_version_selected: "Ausgewählt",
    pdp_version_select: "Auswählen",
    pdp_version_base: "Standardversion",
    pdp_features_included: "Enthaltene Funktionen",
    pdp_trust_warranty_desc: "Vollständige Abdeckung für alle Produkte, Ersatzteile und Reparaturen.",
    pdp_trust_ship_title_long: "Versand 24-48h",
    pdp_trust_ship_desc: "Versand innerhalb Italiens per verfolgtem Expresskurier.",
    pdp_trust_return_title_long: "Einfache 14-tägige Rückgabe",
    pdp_trust_return_desc: "Meinung geändert? Volle Rückerstattung innerhalb von 14 Tagen.",
    pdp_related_kicker: "Ergänzen Sie das Set",
    pdp_related_title: "Empfohlenes Zubehör",
    pdp_related_link: "Gesamtes Zubehör →",
    pdp_option_group_color: "Farbe",
    pdp_option_group_version: "Version",
    pdp_wa_hello: "Hallo audrivio, ich hätte gern Infos zu:",
    badge_sale: "Im Angebot",
    badge_new: "Neu",
    badge_best: "Bestseller",
    seo_pdp_title_suffix: "· Android-Autoradio",
    seo_pdp_desc_fallback: "Plug&Play Android-Autoradio. 30-Minuten-Einbau, 24 Monate Garantie.",

    // === Fase 1 · Auth ===
    auth_kicker_login: "Kundenkonto",
    auth_login_title: "Anmelden",
    auth_login_desc: "Melden Sie sich in Ihrem Konto an, um Bestellungen, Adressen und Daten einzusehen.",
    auth_field_email: "E-Mail",
    auth_field_password: "Passwort",
    auth_login_cta: "Anmelden",
    auth_login_loading: "Anmeldung…",
    auth_login_success: "Willkommen zurück!",
    auth_login_error: "Ungültige Zugangsdaten",
    auth_no_account: "Noch kein Konto?",
    auth_register_link: "Registrieren",
    auth_kicker_register: "Neues Konto",
    auth_register_title: "Erstellen Sie Ihr audrivio-Konto",
    auth_register_desc: "Registrieren Sie sich als Kunde zum Einkaufen oder als Lieferant/Partner, um Zugriff auf den exklusiven Rabatt zu erhalten.",
    auth_role_customer: "Kunde",
    auth_role_supplier: "Lieferant",
    auth_have_account: "Sie haben bereits ein Konto?",
    auth_login_link: "Anmelden",
    auth_benefits_title: "Vorteile",
    auth_benefits_supplier: "Partner-Programm",
    auth_benefits_customer: "Warum registrieren",
    auth_ben_supp_1_t: "Exklusiver Rabatt",
    auth_ben_supp_1_d: "Nach Freigabe automatisch auf jede Bestellung angewendet",
    auth_ben_supp_2_t: "Manuelle Freigabe",
    auth_ben_supp_2_d: "Wir prüfen USt-ID / Steuernummer innerhalb von 24-48 Werkstunden",
    auth_ben_supp_3_t: "Versandpriorität",
    auth_ben_supp_3_d: "Partner-Bestellungen werden zuerst bearbeitet",
    auth_ben_cust_1_t: "Bestellverfolgung",
    auth_ben_cust_1_d: "Verfolgen Sie jede Sendung in Echtzeit",
    auth_ben_cust_2_t: "Historie & Garantie",
    auth_ben_cust_2_d: "Quittungen und Garantie immer griffbereit",
    auth_ben_cust_3_t: "Exklusive Rabatte",
    auth_ben_cust_3_d: "Codes und Aktionen nur für Mitglieder",

    // === Fase 1 · Registration form ===
    reg_err_password_short: "Passwort muss mindestens 8 Zeichen lang sein",
    reg_err_password_mismatch: "Passwörter stimmen nicht überein",
    reg_err_company: "Firmenname ist erforderlich",
    reg_err_taxcode: "Steuernummer / USt-ID ist für Lieferanten erforderlich",
    reg_err_required: "Bitte füllen Sie alle Pflichtfelder aus (mit * markiert)",
    reg_err_generic: "Registrierungsfehler",
    reg_supplier_sent: "Anfrage gesendet — wir kontaktieren Sie nach Freigabe",
    reg_customer_success: "Konto erstellt — willkommen!",
    reg_pending_title: "Anfrage erhalten!",
    reg_pending_desc: "Unser Team prüft Ihre Firmendaten und aktiviert Ihr Konto innerhalb von 24-48 Werkstunden.",
    reg_company: "Firmenname *",
    reg_fullname_supplier: "Vor- und Nachname des Ansprechpartners *",
    reg_fullname_customer: "Vor- und Nachname *",
    reg_email: "E-Mail *",
    reg_phone: "Telefon *",
    reg_address: "Straße *",
    reg_civic: "Hausnr. *",
    reg_postal: "PLZ *",
    reg_city: "Stadt *",
    reg_country: "Land *",
    reg_taxcode_required: "Steuernummer / USt-ID *",
    reg_taxcode_optional: "Steuernummer / USt-ID (optional)",
    reg_notes_label: "Tätigkeit / Notizen (optional)",
    reg_notes_placeholder: "Z. B. Werkstatt spezialisiert auf Car-Audio…",
    reg_password: "Passwort (min. 8 Zeichen) *",
    reg_confirm: "Passwort bestätigen *",
    reg_loading: "Wird erstellt…",
    reg_cta_customer: "Kundenkonto erstellen",
    reg_cta_supplier: "Lieferanten-Anfrage senden",
    reg_supplier_footnote: "Ihre Anfrage wird von unserem Team innerhalb von 24-48 Werkstunden geprüft und freigegeben.",
    country_IT: "Italien", country_AT: "Österreich", country_BE: "Belgien",
    country_BG: "Bulgarien", country_HR: "Kroatien", country_CY: "Zypern",
    country_CZ: "Tschechien", country_DK: "Dänemark", country_EE: "Estland",
    country_FI: "Finnland", country_FR: "Frankreich", country_DE: "Deutschland",
    country_GR: "Griechenland", country_IE: "Irland", country_LV: "Lettland",
    country_LT: "Litauen", country_LU: "Luxemburg", country_MT: "Malta",
    country_NL: "Niederlande", country_PL: "Polen", country_PT: "Portugal",
    country_RO: "Rumänien", country_SK: "Slowakei", country_SI: "Slowenien",
    country_ES: "Spanien", country_SE: "Schweden", country_HU: "Ungarn",
    country_GB: "Vereinigtes Königreich", country_CH: "Schweiz", country_SM: "San Marino",

    // === Fase 1 · About / Contact / Blog / Track / Success ===
    about_seo_title: "Über uns · Das audrivio-Team",
    about_seo_desc: "Ein leidenschaftliches Car-Audio-Team mit über 10 Jahren praktischer Einbauerfahrung. Wir wählen Premium-Android-Hardware und entwickeln modellspezifische Firmware.",
    about_kicker: "Über uns",
    about_h1: "Autoradio, mit der Sorgfalt eines Handwerkers.",
    about_intro: "audrivio entstand aus einem leidenschaftlichen Car-Audio-Team mit über 10 Jahren praktischer Einbauerfahrung. Wir wählen Premium-Android-Hardware aus und entwickeln modellspezifische Firmware.",
    about_mission_title: "Unsere Mission",
    about_mission_desc: "Infotainment-Upgrades für alle zugänglich machen: komplette Kits, Anleitungen und menschlicher Support, wenn's darauf ankommt.",
    about_commit_title: "Unser Versprechen",
    about_commit_desc: "Jedes Produkt wird vor dem Versand getestet. Wenn etwas nicht stimmt, lösen wir es — Punkt.",
    contact_seo_title: "audrivio Kontakt",
    contact_seo_desc: "Kontaktieren Sie uns per E-Mail, WhatsApp oder Kontaktformular. Technischer und Vorverkaufs-Support Montag bis Freitag, 9-18 Uhr.",
    contact_kicker: "Kontakt",
    contact_h1: "Reden wir drüber.",
    contact_intro: "Wir antworten innerhalb von 15 Minuten während der Geschäftszeiten. Für technischen Support ist WhatsApp am schnellsten.",
    contact_name: "Name",
    contact_email: "E-Mail",
    contact_message: "Nachricht",
    contact_sending: "Wird gesendet…",
    contact_send: "Nachricht senden",
    contact_success: "Nachricht gesendet — wir antworten innerhalb von 24h",
    contact_error: "Sende-Fehler",
    contact_support: "Support",
    contact_support_hours: "Mo-Fr 9:00 – 18:00",
    blog_seo_title: "Ratgeber, Einbau, Neuigkeiten · audrivio Blog",
    blog_seo_desc: "Kompatibilitäts-Guides für Android-Autoradios, Schritt-für-Schritt-Einbauanleitungen und Neuigkeiten aus der Car-Audio-Welt. Wöchentlich aktualisiert.",
    blog_kicker: "Ratgeber & Blog",
    blog_h1: "Ratgeber, Einbau, Neuigkeiten.",
    blog_filter_all: "Alle",
    blog_cat_compatibility: "Kompatibilitäts-Guides",
    blog_cat_installation: "Einbauanleitungen",
    blog_cat_news: "Produkt-News",
    blog_read: "Lesen",
    blog_all_articles: "Alle Artikel",
    blog_related_products: "Zugehörige Produkte",
    track_seo_title: "Bestellung verfolgen",
    track_seo_desc: "Geben Sie den Tracking-Code ein, um den Status Ihrer audrivio-Bestellung zu prüfen. Keine Anmeldung nötig.",
    track_kicker: "Tracking",
    track_h1: "Verfolgen Sie Ihre Bestellung",
    track_intro: "Geben Sie den Tracking-Code ein, den Sie beim Bestellen per E-Mail erhalten haben. Kein Konto nötig.",
    track_code_label: "Tracking-Code",
    track_code_placeholder: "z. B. A1B2C3D4",
    track_email_label: "E-Mail",
    track_email_optional: "(optional)",
    track_email_placeholder: "ihre@email.de",
    track_submit: "Verfolgen",
    track_searching: "Suche…",
    track_error_short: "Bitte geben Sie einen Code mit mindestens 6 Zeichen ein",
    track_error_notfound: "Bestellung nicht gefunden",
    track_order_label: "Bestellung",
    track_items: "Artikel",
    track_payment: "Zahlung",
    track_destination: "Zielort",
    track_courier: "Kurier",
    track_help: "Brauchen Sie Hilfe? Kontaktieren Sie uns auf",
    track_help_suffix: "unter Angabe des Codes",
    track_status_processing: "In Bearbeitung",
    track_status_confirmed: "Bestätigt",
    track_status_shipped: "Versandt",
    track_status_delivered: "Zugestellt",
    track_status_cancelled: "Storniert",
    pay_status_pending: "Zahlung ausstehend",
    pay_status_paid: "Bezahlt",
    pay_status_refunded: "Erstattet",
    success_paypal_confirming_h1: "Ihre PayPal-Zahlung wird bestätigt…",
    success_paypal_confirming_desc: "Bitte diese Seite nicht schließen, es dauert nur wenige Sekunden.",
    success_paypal_error_h1: "Zahlung fehlgeschlagen",
    success_paypal_error_generic: "PayPal-Zahlung konnte nicht abgeschlossen werden.",
    success_paypal_error_capture: "PayPal-Capture-Fehler.",
    success_retry_payment: "Zahlung erneut versuchen",
    success_h1: "Bestellung bestätigt",
    success_desc: "Danke! Sie erhalten in Kürze eine E-Mail mit den Details.",
    success_order_label: "Bestellung",
    success_payment_status_label: "Zahlungsstatus:",
    success_total_label: "Gesamt:",
    success_email_sent: "Wir haben Ihnen eine Bestätigungs-E-Mail gesendet.",
    success_back_home: "Zurück zur Startseite",

    // === Fase 1 · Nav / Footer / Cards / Klarna / Wishlist ===
    nav_accessories: "Zubehör",
    footer_tagline: "Dedizierte Plug&Play Android-Autoradios, speziell für Ihr Modell entwickelt. Kein Kabelschneiden, kein Risiko.",
    footer_track_order: "Bestellung verfolgen",
    footer_guides: "Ratgeber",
    footer_support_hours: "Support Mo-Fr 9-18 Uhr",
    card_price_from: "Ab",
    card_choose: "Wählen",
    card_choose_variant: "Variante wählen",
    klarna_chip_pay3: "In 3 Raten",
    klarna_pay_prefix: "Zahlen Sie in",
    klarna_pay_3: "3 Raten",
    klarna_pay_suffix: "zinsfrei",
    klarna_per_month: "/Monat",
    klarna_no_fee: "keine Gebühren",
    klarna_learn_more: "So funktioniert's",
    klarna_hero_title: "In 3 zinsfreien Raten bezahlen",
    klarna_hero_desc: "Jede Bestellung in 3 Zahlungen aufteilen · keine Gebühren · sofortige Genehmigung an der Kasse",
    klarna_bullet_1: "Keine Zinsen",
    klarna_bullet_2: "Keine Gebühren",
    klarna_bullet_3: "Soft-Check-Genehmigung",
    wl_login_hint: "Anmelden, um Favoriten zu speichern",
    wl_removed: "Aus Favoriten entfernt",
    wl_added: "Zu Favoriten hinzugefügt",
    wl_error: "Etwas ist schiefgegangen, bitte erneut versuchen",
    wl_aria_remove: "Aus Favoriten entfernen",
    wl_aria_add: "Zu Favoriten hinzufügen",
    wl_in_list: "In Favoriten",
    wl_label: "Favoriten",
  },

  es: {
    // Navigation
    nav_home: "Inicio",
    nav_catalog: "Catálogo",
    nav_blog: "Guías y Blog",
    nav_about: "Sobre nosotros",
    nav_contact: "Contacto",

    // Header
    header_wa_cta: "Contáctanos para más info",
    header_cart: "Carrito",
    header_login: "Iniciar sesión",
    header_account_my: "Mi cuenta",
    header_account_orders: "Mis pedidos",
    header_account_logout: "Cerrar sesión",
    header_promo: "Envío exprés gratis 24-48h · Pago contra reembolso disponible · Garantía 24 meses",

    // CTAs
    cta_find: "Encuentra tu modelo",
    cta_catalog: "Ver catálogo",
    trust_warranty: "Garantía incluida",
    trust_shipping: "Envío 24-48h",
    trust_wa: "Soporte WhatsApp",

    // Home sections
    section_why: "Por qué elegir audrivio",
    section_best: "Los más vendidos",
    section_sale: "En oferta ahora",
    section_how: "Cómo funciona",
    section_reviews: "Lo que dicen los clientes",
    hero_badge: "Autorradios Android Plug&Play",
    hero_title: "Tu habitáculo, por fin al nivel de 2026.",
    hero_subtitle: "Autorradios Android a medida para tu modelo. Cero empalmes, instalación en 30 minutos, garantía incluida.",
    why_kicker: "Por qué nosotros",
    best_kicker: "Más vendidos",
    sale_kicker: "Ofertas",
    how_kicker: "El proceso",
    reviews_kicker: "Reseñas verificadas",
    see_all: "Ver todos",
    see_all_sale: "Ver todas",
    why_1_title: "Garantía 24 meses incluida",
    why_1_desc: "Cada radio audrivio está cubierta por nuestra garantía oficial, con soporte en español e italiano.",
    why_2_title: "Asistencia real por WhatsApp",
    why_2_desc: "Equipo técnico que responde en 15 minutos en horario laboral.",
    why_3_title: "Instalación fácil Plug&Play",
    why_3_desc: "Cero empalmes. Solo conecta los conectores dedicados para tu modelo.",
    why_4_title: "Devoluciones fáciles 14 días",
    why_4_desc: "¿Cambio de opinión? Recogemos el producto en 14 días, envío incluido.",
    step_1_title: "Elige tu coche",
    step_1_desc: "Marca, modelo y año: mostramos solo la radio compatible.",
    step_2_title: "Recibe el kit completo",
    step_2_desc: "Marco, arnés, soportes y adaptadores — ya en la caja.",
    step_3_title: "Instala en 30-40 minutos",
    step_3_desc: "Sin cortar cables. Tutorial paso a paso incluido.",

    // Vehicle finder
    finder_title: "Encuentra la radio adecuada para tu coche",
    finder_brand: "Marca",
    finder_model: "Modelo",
    finder_cta: "Verificar compatibilidad",
    finder_console_title: "Encuentra la radio para tu coche",
    finder_console_sub: "SELECCIONA MARCA · MODELO",
    finder_label_brand: "Marca",
    finder_label_model: "Modelo",
    finder_placeholder_brand: "Seleccionar marca",
    finder_placeholder_model_pre: "Primero elige la marca",
    finder_placeholder_model: "Seleccionar modelo",
    finder_foot_kit: "· kit plug&play",
    finder_foot_ship: "· 24-48h",
    finder_foot_warranty: "· 24 meses",

    // Product / cart
    add_to_cart: "Añadir al carrito",
    ask_whatsapp: "Pregunta por WhatsApp",
    view_cart: "Ver carrito",
    checkout: "Ir al pago",
    empty_cart: "El carrito está vacío",

    // Footer
    footer_shop: "Tienda",
    footer_support: "Soporte",
    footer_legal: "Legal",
    footer_manage_cookies: "Gestionar cookies",
    footer_newsletter_title: "Newsletter",
    footer_newsletter_desc: "Guías gratuitas y ofertas exclusivas para tu coche.",
    newsletter_placeholder: "Tu email",
    subscribe: "Suscribirse",
    footer_rights: "Todos los derechos reservados.",

    // Policy links
    policy_refund: "Política de reembolso",
    policy_privacy: "Política de privacidad",
    policy_terms: "Términos y condiciones",
    policy_shipping: "Política de envío",
    policy_legal: "Aviso legal",
    policy_cookies: "Política de cookies",
    policy_updated: "Última actualización",

    // Cookie banner
    cookie_title: "Utilizamos cookies",
    cookie_desc: "Usamos cookies técnicas y, con tu consentimiento, cookies analíticas y de marketing para mejorar tu experiencia. Puedes aceptarlas todas, rechazarlas o gestionar tus preferencias.",
    cookie_accept: "Aceptar todo",
    cookie_reject: "Rechazar",
    cookie_customize: "Personalizar",
    cookie_save: "Guardar preferencias",
    cookie_pref_necessary: "Necesarias",
    cookie_pref_necessary_desc: "Cookies técnicas imprescindibles para el funcionamiento del sitio.",
    cookie_pref_analytics: "Analíticas",
    cookie_pref_analytics_desc: "Nos ayudan a entender cómo se usa el sitio de forma anónima.",
    cookie_pref_marketing: "Marketing",
    cookie_pref_marketing_desc: "Personalizan la publicidad según tus intereses.",
    cookie_more: "Leer la Política de Cookies",

    // Policy pages
    refund_title: "Política de reembolso",
    refund_intro: "En audrivio tu satisfacción nos importa. Puedes devolver los productos en 14 días desde la entrega sin necesidad de dar motivo, tal como establece la normativa europea de consumo.",
    refund_h1: "Cómo solicitar una devolución",
    refund_p1: "Para ejercer el derecho de desistimiento, envíanos una solicitud por escrito a support@audrivio.com dentro de los 14 días desde la entrega. Te daremos todas las instrucciones para la devolución.",
    refund_h2: "Estado del producto",
    refund_p2: "El producto debe devolverse en su embalaje original, íntegro, con todos los accesorios y manuales. Los productos dañados por uso indebido no podrán ser reembolsados.",
    refund_h3: "Plazos de reembolso",
    refund_p3: "Una vez recibido y verificado el producto, procederemos al reembolso en 14 días hábiles utilizando el mismo método de pago empleado en la compra.",
    refund_h4: "Gastos de envío de la devolución",
    refund_p4: "Los gastos de envío de la devolución corren a cargo del cliente, salvo pacto en contrario en caso de producto defectuoso o error en el envío.",
    refund_h5: "Productos defectuosos",
    refund_p5: "Si recibes un producto defectuoso o no conforme, contáctanos inmediatamente. En estos casos los gastos de devolución y sustitución corren enteramente a nuestro cargo.",
    refund_h6: "Regalos promocionales",
    refund_p6: "Los regalos recibidos con un código promocional deben devolverse intactos junto con el autorradio en caso de desistimiento o devolución; de lo contrario, su precio de catálogo podrá descontarse del reembolso. Los regalos no son canjeables por dinero.",

    privacy_title: "Política de privacidad",
    privacy_intro: "Esta Política de privacidad describe cómo audrivio recoge, utiliza y protege tus datos personales conforme al Reglamento UE 2016/679 (RGPD).",
    privacy_h1: "Responsable del tratamiento",
    privacy_p1: "audrivio es el responsable del tratamiento de los datos personales recogidos a través de este sitio. Para cualquier solicitud escribe a privacy@audrivio.com.",
    privacy_h2: "Tipos de datos recogidos",
    privacy_p2: "Recogemos datos de identificación (nombre, apellidos), datos de contacto (email, teléfono, dirección), datos de pago (gestionados de forma segura por proveedores certificados) y datos de navegación (dirección IP, cookies, dispositivo).",
    privacy_h3: "Finalidades del tratamiento",
    privacy_p3: "Utilizamos tus datos para: gestionar pedidos y envíos, atención al cliente, obligaciones fiscales, envío de comunicaciones comerciales (solo con consentimiento previo), análisis estadístico anónimo.",
    privacy_h4: "Tus derechos",
    privacy_p4: "Tienes derecho a acceder, rectificar, suprimir, limitar u oponerte al tratamiento de tus datos, solicitar la portabilidad o retirar tu consentimiento en cualquier momento escribiendo a privacy@audrivio.com.",
    privacy_h5: "Conservación de datos",
    privacy_p5: "Los datos se conservan durante el tiempo estrictamente necesario para las finalidades del tratamiento, respetando las obligaciones legales (generalmente 10 años a efectos fiscales).",
    privacy_h6: "Compartir con terceros",
    privacy_p6: "Tus datos no se venden. Pueden compartirse con transportistas, pasarelas de pago, proveedores tecnológicos y autoridades competentes, exclusivamente para las finalidades indicadas.",

    terms_title: "Términos y condiciones",
    terms_intro: "El uso del sitio audrivio implica la aceptación íntegra de estos Términos y condiciones de venta. Te invitamos a leerlos atentamente antes de comprar.",
    terms_h1: "Objeto",
    terms_p1: "Estos términos regulan la venta a distancia de autorradios Android Plug&Play y accesorios a través de audrivio, entre el vendedor y el usuario consumidor conforme a la normativa europea de consumo.",
    terms_h2: "Pedidos y contrato",
    terms_p2: "El contrato se considera celebrado en el momento de la confirmación del pedido por email por parte de audrivio. Nos reservamos el derecho de rechazar un pedido por razones de disponibilidad o seguridad.",
    terms_h3: "Precios y pagos",
    terms_p3: "Todos los precios están expresados en euros e incluyen IVA. Aceptamos tarjetas de crédito, transferencia bancaria, PayPal, Klarna (pago a plazos) y contra reembolso donde esté disponible.",
    terms_h4: "Entrega",
    terms_p4: "La entrega se realiza en 24-48 horas hábiles en el territorio italiano mediante mensajería exprés. Para islas y zonas remotas los plazos pueden alcanzar los 5 días hábiles.",
    terms_h5: "Garantía legal",
    terms_p5: "Todos los productos están cubiertos por la garantía legal de conformidad de 24 meses para los consumidores, tal como establece la normativa europea de consumo.",
    terms_h6: "Jurisdicción",
    terms_p6: "Para cualquier controversia será competente el tribunal del lugar de residencia o domicilio del consumidor, si se encuentra en la UE; de lo contrario, será competente el tribunal de Milán.",
    terms_h7: "Promociones con productos de regalo",
    terms_p7: "Los productos de regalo (p. ej. micrófono externo, cámara trasera) vinculados a un código promocional se añaden gratis solo al comprar un autorradio Android elegible (precio superior a 150 €), hasta agotar existencias y dentro de la validez del código (duración, número de usos, países). No tienen valor comercial en el pedido, no son canjeables por dinero ni acumulables con otros códigos.",

    shipping_title: "Política de envío",
    shipping_intro: "Enviamos a toda Italia con transportistas certificados y ofrecemos seguimiento en tiempo real. Aquí tienes toda la información útil sobre nuestra logística.",
    shipping_h1: "Plazos de entrega",
    shipping_p1: "Los pedidos recibidos antes de las 15:00 en días laborables se procesan y envían en el mismo día. La entrega suele realizarse en 24-48 horas en toda la Italia continental.",
    shipping_h2: "Islas y zonas remotas",
    shipping_p2: "Para Sicilia, Cerdeña y las islas menores los plazos pueden ampliarse hasta 4-5 días hábiles. Las zonas rurales o remotas pueden requerir días adicionales.",
    shipping_h3: "Gastos de envío",
    shipping_p3: "El envío exprés es gratuito para todos los pedidos superiores a 99€. Para pedidos de menor importe se aplica una contribución fija de 9,90€.",
    shipping_h4: "Pago contra reembolso",
    shipping_p4: "Es posible solicitar el pago contra reembolso con un suplemento de 4,90€. Servicio disponible solo para pedidos inferiores a 1.000€.",
    shipping_h5: "Seguimiento",
    shipping_p5: "En cuanto el paquete se entrega al mensajero, recibes por email un enlace de seguimiento para monitorear el envío paso a paso, en tiempo real.",
    shipping_h6: "Paquetes no entregados",
    shipping_p6: "Si no estás en casa en el momento de la entrega, el mensajero dejará un aviso y volverá a pasar los días siguientes. Contáctanos si el paquete no llega en 7 días hábiles.",

    legal_title: "Aviso legal",
    legal_intro: "Este aviso legal contiene toda la información requerida por la normativa italiana y europea en materia de comercio electrónico.",
    legal_h1: "Denominación",
    legal_p1: "El sitio audrivio es gestionado por audrivio, con sede en Italia. Inscripción en el Registro Mercantil y CIF disponibles a petición escribiendo a legal@audrivio.com.",
    legal_h2: "Contactos",
    legal_p2: "Email: support@audrivio.com · WhatsApp: +39 351 129 4525 · Asistencia de lunes a viernes, 9:00 – 18:00.",
    legal_h3: "Propiedad intelectual",
    legal_p3: "Todos los contenidos presentes en el sitio (textos, imágenes, logotipos, vídeos, diseño) son propiedad de audrivio o de sus respectivos titulares y están protegidos por las leyes de propiedad intelectual.",
    legal_h4: "Limitación de responsabilidad",
    legal_p4: "audrivio se esfuerza por mantener la información del sitio actualizada, pero no garantiza la ausencia de errores técnicos o tipográficos. Las especificaciones de los productos pueden variar sin previo aviso.",
    legal_h5: "Resolución de litigios (ODR)",
    legal_p5: "En cumplimiento del Regl. UE 524/2013, los consumidores pueden acceder a la plataforma europea de resolución de litigios en línea en ec.europa.eu/consumers/odr.",
  },
};
